webpackJsonp([13],{

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOKEN; });
/* unused harmony export EXPIRES_ON */
/* unused harmony export EXPIRES_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER_ID; });
/* unused harmony export EMP_ID */
/* unused harmony export FULL_NAME */
/* unused harmony export ROLE */
/* unused harmony export EMAIL */
/* unused harmony export O365_TOKEN */
/* unused harmony export USER_IMAGE */
/* unused harmony export DEVICE_ADMIN */
/* unused harmony export IS_ADMIN */
/* unused harmony export STATION_DISPLAY */
/* unused harmony export PICKING_DISPLAY */
/* unused harmony export REPORT_AS_FINISH_DISPLAY */
/* unused harmony export JOB_CARD_DISPLAY */
/* unused harmony export WARE_HOUSE_DISPLAY */
/* unused harmony export STATION_NAME_DISPLAY */
/* unused harmony export DISPLAY_SETTINGS */
/* unused harmony export DEVICE_ID */
/* unused harmony export DEVICE_NAME */
/* unused harmony export DISPLAY_NAME */
/* unused harmony export TABLE_NAME_ACTIVE */
/* unused harmony export URL_INCOMING */
/* harmony export (immutable) */ __webpack_exports__["d"] = authenticationDevice;
/* harmony export (immutable) */ __webpack_exports__["c"] = authentication;
/* harmony export (immutable) */ __webpack_exports__["o"] = setO365TokenCookie;
/* unused harmony export getO365Token */
/* harmony export (immutable) */ __webpack_exports__["p"] = setUserImageCookie;
/* harmony export (immutable) */ __webpack_exports__["n"] = getUserImageCookie;
/* harmony export (immutable) */ __webpack_exports__["f"] = clearToken;
/* harmony export (immutable) */ __webpack_exports__["g"] = getAllCookies;
/* harmony export (immutable) */ __webpack_exports__["l"] = getToken;
/* harmony export (immutable) */ __webpack_exports__["j"] = getFullName;
/* unused harmony export getDeviceId */
/* unused harmony export getDeviceInfoCookie */
/* unused harmony export getRole */
/* unused harmony export getExpireDate */
/* harmony export (immutable) */ __webpack_exports__["i"] = getDeviceAdmin;
/* harmony export (immutable) */ __webpack_exports__["k"] = getIsAdmin;
/* harmony export (immutable) */ __webpack_exports__["e"] = authenticationEmpMode;
/* harmony export (immutable) */ __webpack_exports__["h"] = getAllCookiesDisplay;
/* unused harmony export setCookieDisplay */
/* unused harmony export clearCookieDisplay */
/* unused harmony export setDisplayName */
/* unused harmony export getDisplayName */
/* unused harmony export setTableNameActive */
/* unused harmony export getTableNameActive */
/* unused harmony export setUrlIncoming */
/* harmony export (immutable) */ __webpack_exports__["m"] = getUrlIncoming;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_64__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_base_64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var TOKEN = 'token';
var EXPIRES_ON = 'expires_on';
var EXPIRES_DATE = 'expires_date';
var USER_ID = 'user_id';
var EMP_ID = 'emp_id';
var FULL_NAME = 'fullname';
var ROLE = 'role';
var EMAIL = 'email';
var O365_TOKEN = 'o365_token';
var USER_IMAGE = 'user_image';
var DEVICE_ADMIN = 'DEVICE_ADMIN';
var IS_ADMIN = 'is_admin';
var STATION_DISPLAY = 'station_display';
var PICKING_DISPLAY = 'picking_display';
var REPORT_AS_FINISH_DISPLAY = 'report_as_finish_display';
var JOB_CARD_DISPLAY = 'job_card_display';
var WARE_HOUSE_DISPLAY = 'ware_house_display';
var STATION_NAME_DISPLAY = 'station_name_display';
var DISPLAY_SETTINGS = 'display_settings';
var DEVICE_ID = 'deviceId';
var DEVICE_NAME = 'deviceName';

var DISPLAY_NAME = 'display_name';
var TABLE_NAME_ACTIVE = 'table_name_active';
var URL_INCOMING = 'url_incoming';
function getCookie(key) {
    try {
        var value = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get(key);
        var setValue = '';

        if (value && typeof value === 'string') {
            setValue = __WEBPACK_IMPORTED_MODULE_0_base_64___default.a.decode(value);
        }

        return setValue;
    } catch (error) {
        return null;
    }
}

function setCookie(key, value, expires) {
    var valueToString = String(value);
    var setValue = '';
    if (typeof valueToString === 'string') {
        setValue = __WEBPACK_IMPORTED_MODULE_0_base_64___default.a.encode(valueToString);
    }
    if (expires && typeof expires === 'number' && expires > 0) {
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(key, setValue, { expires: expires });
    } else {
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(key, setValue);
    }
}

function removeCookie(key) {
    __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.remove(key);
}
function authenticationDevice(responseData) {
    var _responseData$data = responseData.data,
        token = _responseData$data.token,
        expiresOn = _responseData$data.expiresOn,
        expiresDate = _responseData$data.expiresDate,
        name = _responseData$data.name,
        deviceId = _responseData$data.deviceId;

    clearToken();
    setCookie(FULL_NAME, null);
    setCookie(EMAIL, null);
    setCookie(USER_ID, null);

    setCookie(TOKEN, token);
    setCookie(EXPIRES_DATE, expiresDate);
    setCookie(EXPIRES_ON, expiresOn);
    setCookie(DEVICE_ADMIN, true);
    setCookie(IS_ADMIN, true);
    setCookie(DEVICE_ID, deviceId);
    setCookie(DEVICE_NAME, name);
}

function authentication(dataAuth, isRemember) {
    var _dataAuth$user = dataAuth.user,
        email = _dataAuth$user.email,
        fullName = _dataAuth$user.fullName,
        id = _dataAuth$user.id,
        deviceAdmin = _dataAuth$user.deviceAdmin,
        isAdmin = _dataAuth$user.isAdmin,
        token = dataAuth.token,
        expiresDate = dataAuth.expiresDate,
        expiresOn = dataAuth.expiresOn;


    clearToken();
    setCookie(FULL_NAME, fullName);
    setCookie(EMAIL, email);
    setCookie(USER_ID, id);

    setCookie(TOKEN, token);
    setCookie(EXPIRES_DATE, expiresDate);
    setCookie(EXPIRES_ON, expiresOn);
    setCookie(DEVICE_ADMIN, deviceAdmin);
    setCookie(IS_ADMIN, isAdmin);
}
function setO365TokenCookie(data) {
    setCookie(O365_TOKEN, data);
}
function getO365Token() {
    return getCookie(O365_TOKEN);
}

function setUserImageCookie(data) {
    setCookie(USER_IMAGE, data);
}
function getUserImageCookie() {
    return getCookie(USER_IMAGE);
}
function clearToken() {
    removeCookie(TOKEN);
    removeCookie(EXPIRES_DATE);
    removeCookie(USER_ID);
    removeCookie(FULL_NAME);
    removeCookie(EMAIL);
    removeCookie(IS_ADMIN);
    removeCookie(DEVICE_ADMIN);
    removeCookie(URL_INCOMING);
    removeCookie(DEVICE_ID);
    removeCookie(DEVICE_ADMIN);
    removeCookie(DEVICE_NAME);
}

function getAllCookies() {
    var _ref;

    return _ref = {}, _defineProperty(_ref, TOKEN, getCookie(TOKEN)), _defineProperty(_ref, EXPIRES_ON, getCookie(EXPIRES_ON)), _defineProperty(_ref, EXPIRES_DATE, getCookie(EXPIRES_DATE)), _defineProperty(_ref, USER_ID, getCookie(USER_ID)), _defineProperty(_ref, DEVICE_ADMIN, getCookie(DEVICE_ADMIN)), _defineProperty(_ref, IS_ADMIN, getCookie(IS_ADMIN)), _ref;
}

function getToken() {
    return getCookie(TOKEN);
}

function getFullName() {
    return getCookie(FULL_NAME);
}

function getDeviceId() {
    return getCookie(DEVICE_ID);
}
function getDeviceInfoCookie() {
    return {
        DEVICE_NAME: getCookie(DEVICE_NAME),
        DEVICE_ADMIN: getCookie(DEVICE_ADMIN),
        DEVICE_ID: getCookie(DEVICE_ID)
    };
}

function getRole() {
    return getCookie(ROLE);
}

function getExpireDate() {
    return getCookie(EXPIRES_DATE);
}

function getDeviceAdmin() {
    return getCookie(DEVICE_ADMIN);
}

function getIsAdmin() {
    return getCookie(IS_ADMIN);
}

function authenticationEmpMode(dataAuth, isRemember) {
    var _dataAuth$data = dataAuth.data,
        _dataAuth$data$user = _dataAuth$data.user,
        email = _dataAuth$data$user.email,
        empId = _dataAuth$data$user.empId,
        fullName = _dataAuth$data$user.fullName,
        id = _dataAuth$data$user.id,
        deviceAdmin = _dataAuth$data$user.deviceAdmin,
        isAdmin = _dataAuth$data$user.isAdmin,
        token = _dataAuth$data.token,
        expiresDate = _dataAuth$data.expiresDate,
        expiresOn = _dataAuth$data.expiresOn;


    clearToken();
    setCookie(FULL_NAME, fullName);
    setCookie(EMAIL, email);
    setCookie(USER_ID, id);
    setCookie(EMP_ID, empId);
    setCookie(TOKEN, token);
    setCookie(EXPIRES_DATE, expiresDate);
    setCookie(EXPIRES_ON, expiresOn);
    // setCookie(DEVICE_ADMIN, deviceAdmin)
    // setCookie(IS_ADMIN, isAdmin)
}

//getAllCokiesDisplay
function getAllCookiesDisplay() {
    var _ref2;

    return _ref2 = {}, _defineProperty(_ref2, STATION_DISPLAY, getCookie(STATION_DISPLAY)), _defineProperty(_ref2, PICKING_DISPLAY, getCookie(PICKING_DISPLAY)), _defineProperty(_ref2, REPORT_AS_FINISH_DISPLAY, getCookie(REPORT_AS_FINISH_DISPLAY)), _defineProperty(_ref2, JOB_CARD_DISPLAY, getCookie(JOB_CARD_DISPLAY)), _defineProperty(_ref2, WARE_HOUSE_DISPLAY, getCookie(WARE_HOUSE_DISPLAY)), _defineProperty(_ref2, USER_ID, getCookie(USER_ID)), _defineProperty(_ref2, EMP_ID, getCookie(EMP_ID)), _defineProperty(_ref2, FULL_NAME, getCookie(FULL_NAME)), _defineProperty(_ref2, STATION_NAME_DISPLAY, getCookie(STATION_NAME_DISPLAY)), _defineProperty(_ref2, DISPLAY_NAME, getCookie(DISPLAY_NAME)), _defineProperty(_ref2, TABLE_NAME_ACTIVE, getCookie(TABLE_NAME_ACTIVE)), _ref2;
}

//set all cookie display
function setCookieDisplay(data) {
    var stationDisplay = data.stationDisplay,
        pickingDisplay = data.pickingDisplay,
        reportAsFinishDisplay = data.reportAsFinishDisplay,
        jobCardDisplay = data.jobCardDisplay,
        warehouseDisplay = data.warehouseDisplay,
        stationName = data.stationName;

    setCookie(STATION_DISPLAY, stationDisplay);
    setCookie(PICKING_DISPLAY, pickingDisplay);
    setCookie(REPORT_AS_FINISH_DISPLAY, reportAsFinishDisplay);
    setCookie(JOB_CARD_DISPLAY, jobCardDisplay);
    setCookie(WARE_HOUSE_DISPLAY, warehouseDisplay);
    setCookie(STATION_NAME_DISPLAY, stationName);
}

//clear all cookie display
function clearCookieDisplay() {
    removeCookie(STATION_DISPLAY);
    removeCookie(PICKING_DISPLAY);
    removeCookie(REPORT_AS_FINISH_DISPLAY);
    removeCookie(JOB_CARD_DISPLAY);
    removeCookie(WARE_HOUSE_DISPLAY);
    removeCookie(STATION_NAME_DISPLAY);
    removeCookie(USER_ID);
    removeCookie(EMP_ID);
    removeCookie(FULL_NAME);
    removeCookie(DISPLAY_NAME);
    removeCookie(TABLE_NAME_ACTIVE);
}

function setDisplayName(name) {
    console.log(name);
    setCookie(DISPLAY_NAME, name);
}

function getDisplayName() {
    return _defineProperty({}, DISPLAY_NAME, getCookie(DISPLAY_NAME));
}

function setTableNameActive(name) {
    setCookie(TABLE_NAME_ACTIVE, name);
}

function getTableNameActive() {
    return _defineProperty({}, TABLE_NAME_ACTIVE, getCookie(TABLE_NAME_ACTIVE));
}
function setUrlIncoming(data) {
    setCookie(URL_INCOMING, data);
}
function getUrlIncoming() {
    return getCookie(URL_INCOMING);
}

/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getErrorList;
/* unused harmony export getCallAPI */
/* harmony export (immutable) */ __webpack_exports__["b"] = getLoading;
function getErrorList(state) {
    return state.errorList;
}

function getCallAPI(state) {
    return state.callAPI;
}

function getLoading(state) {
    return state.isLoading;
}

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

module.exports = {"search":{"title":"Search","text":"ค้นหา","orderNo":"Order No.","drawingNo":"Drawing No.","customerName":"Customer Name","customerCode":"Customer Code","code":"Code","model":"Model","priority":"Priority","notFound":"Search Not Found","status":"Status","drawingRev":"Rev","coilSize":"Coil Size","pipeType":"Pipe type & Pattern","searchText":"ค้นหา","showLess":"แสดงแบบย่อ","showAll":"แสดงทั้งหมด"}}

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/lib/api.js
var api = __webpack_require__(248);

// EXTERNAL MODULE: ./src/lib/auth.js
var auth = __webpack_require__(155);

// CONCATENATED MODULE: ./src/lib/setting.js
var timeZone = 'Asia/Bangkok';
var timeFormat = 'YYYY-MM-DDTHH:mm:ss';
var defaultDateFormat = 'MMMM DD, YYYY';
var defaultDateTimeFormat = 'MMMM DD, YYYY HH:mm';
// CONCATENATED MODULE: ./src/lib/shareFunctions.js
var mapOptions = function mapOptions(data) {
    var options = [];
    options = data.map(function (d) {
        return {
            value: d.id,
            text: d.name
        };
    });
    return options;
};
// CONCATENATED MODULE: ./src/lib/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return api["c" /* REDIRECT_O365_URI */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api["b" /* CORE_API_ENDPOINT */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return api["d" /* REDIRECT_O365_URI_2 */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return api["a" /* CLIENT_ID */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return api["e" /* VERSION_NO */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return auth["a" /* TOKEN */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return auth["b" /* USER_ID */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["d" /* authenticationDevice */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["c" /* authentication */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["o" /* setO365TokenCookie */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["p" /* setUserImageCookie */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return auth["n" /* getUserImageCookie */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return auth["f" /* clearToken */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return auth["g" /* getAllCookies */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["l" /* getToken */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return auth["j" /* getFullName */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return auth["i" /* getDeviceAdmin */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return auth["k" /* getIsAdmin */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return auth["e" /* authenticationEmpMode */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return auth["h" /* getAllCookiesDisplay */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return auth["m" /* getUrlIncoming */]; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeZone; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return timeFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defaultDateFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return defaultDateTimeFormat; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return mapOptions; });





/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/middlewares/api.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var CALL_API = Symbol('CALL_API');

var resStatusError = [400, 401, 402, 403, 404, 422, 500, 501, 502, 503];

function getAction(type, action, state, res) {
    return new Promise(function (resolve, reject) {
        if (!res) return resolve({ type: type });
        if (resStatusError.includes(res.status)) {
            return reject({ statusCode: res.status, statusText: res.statusText, errorList: state.errorList });
        }

        if ((typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'object') {
            if (type.payload) {
                var payload = type.payload(action, state, res);
                if (typeof payload.then === 'function') {
                    //promise
                    return payload.then(function (data) {
                        return resolve({ type: type.type, payload: data });
                    });
                } else {
                    return resolve({ type: type.type, payload: payload });
                }
            }

            return resolve({ type: type.type });
        }

        res.json().then(function (payload) {
            return resolve({ type: type, payload: payload });
        });
    });
}

/* harmony default export */ var api = (function (_ref) {
    var getState = _ref.getState;
    return function (next) {
        return function (action) {
            if (_typeof(action[CALL_API]) !== 'object') return next(action);

            var _action$CALL_API = action[CALL_API],
                endpoint = _action$CALL_API.endpoint,
                _action$CALL_API$meth = _action$CALL_API.method,
                method = _action$CALL_API$meth === undefined ? 'GET' : _action$CALL_API$meth,
                headers = _action$CALL_API.headers,
                body = _action$CALL_API.body,
                types = _action$CALL_API.types;

            var _types = _slicedToArray(types, 3),
                request = _types[0],
                success = _types[1],
                failure = _types[2];

            var callBack = success.callBack;

            var state = getState();
            getAction(request, action, state).then(function (action) {
                return next(action);
            });

            if (callBack) {
                var url = { endpoint: endpoint, method: method };
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).then(function () {
                    return callBack();
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true, url: url });
                });
            } else {
                fetch(endpoint, { method: method, headers: headers, body: body }).then(function (res) {
                    return getAction(success, action, state, res);
                }).then(function (action) {
                    return next(action);
                }).catch(function (err) {
                    return next({ type: failure, payload: err, error: true });
                });
            }
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/checkToken.js
var checkToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/* harmony default export */ var checkToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : checkToken__typeof(entry)) !== 'object') return next(action);

            next(action);
        };
    };
});
// EXTERNAL MODULE: ./src/lib/auth.js
var auth = __webpack_require__(155);

// CONCATENATED MODULE: ./src/middlewares/setToken.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var setToken__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/* harmony default export */ var setToken = (function (store) {
    return function (next) {
        return function (action) {
            var entry = action[CALL_API];

            if ((typeof entry === 'undefined' ? 'undefined' : setToken__typeof(entry)) !== 'object') return next(action);

            var token = null;
            var entryType = entry.types[0];

            if (entryType.startsWith('CORE')) {
                token = Object(auth["l" /* getToken */])();
            }

            if (!token) return next(action);
            //  return false
            entry.headers = _extends({}, entry.headers);
            if (token) {
                entry.headers.Authorization = 'Bearer ' + token;
            }
            entry.headers['Access-Control-Allow-Origin'] = '*';
            entry.headers['Access-Control-Allow-Methods'] = '*';
            entry.headers['Access-Control-Allow-Headers'] = 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With';

            next(action);
        };
    };
});
// CONCATENATED MODULE: ./src/middlewares/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return api; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return CALL_API; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return checkToken; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return setToken; });




/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REDIRECT_O365_URI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CORE_API_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REDIRECT_O365_URI_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLIENT_ID; });
/* unused harmony export ACTIVE_ITEM_TAB */
/* unused harmony export ACTIVE_ITEM2_TAB */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VERSION_NO; });
/* unused harmony export projectName */
// export const CORE_API_ENDPOINT = "https://api-npi.herokuapp.com"
//
// // Localhost
// export const CORE_API_ENDPOINT = "http://localhost:2600"
// export const REDIRECT_O365_URI = 'http://localhost:8080/login';
var REDIRECT_O365_URI = "https://cighub.cigblusolutions.com/login";
// export const AX_URL = "http://localhost:8080"

// ProdLine UAT Server
// export const QR_READER_ENDPOINT = "https://imsv2test.cigblusolutions.com"
var CORE_API_ENDPOINT = "https://cighub.cigblusolutions.com/api";
// export const REDIRECT_O365_URI_2 = "http://localhost:8080/amth"
var REDIRECT_O365_URI_2 = "https://cighub.cigblusolutions.com/amth";
// export const REDIRECT_O365_URI_2 = "https://cighubtest.cigblusolutions.com/amth"
// export const REDIRECT_O365_URI = "https://cighubtest.cigblusolutions.com/login"
// export const AX_URL = "https://ciguat.sandbox.operations.dynamics.com"

// ProdLine Prod Server
// export const QR_READER_ENDPOINT = "https://imsv2.cigblusolutions.com"
// export const CORE_API_ENDPOINT = "https://productionline.cigblusolutions.com/api"
// export const REDIRECT_O365_URI = "https://productionline.cigblusolutions.com/login"
// export const AX_URL = "https://cib.operations.dynamics.com"

var CLIENT_ID = '0b1bf20d-a148-44d2-8932-027dbaf66a46';
var ACTIVE_ITEM_TAB = 6; //6
var ACTIVE_ITEM2_TAB = 2; //6
var VERSION_NO = '1.3.0';

var projectName = 'PROD-Line ';

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export imagePageLogin */
/* unused harmony export image_header */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return iconCloseModalError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return iconLogoModalError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogoModalError; });
/* unused harmony export iconCloseOnBG */
/* unused harmony export iconArrowLeft */
/* unused harmony export iconArrowRight */
var imagePageLogin = '/assets/images/logo-page-login.png';
var image_header = '/assets/images/logo-mene.png';

var iconCloseModalError = '/assets/images/clear.png';
var iconLogoModalError = '/assets/images/icon-deleteCircle-fff.png';
var LogoModalError = '/assets/images/warning.png';
var iconCloseOnBG = '/assets/images/icon-delete-fff.png';

//Image Next Prev
var iconArrowLeft = '/assets/images/icon-arrow-left.png';
var iconArrowRight = '/assets/images/icon-arrow-right.png';

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(252);


/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(0);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(86);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/react-hot-loader/index.js
var react_hot_loader = __webpack_require__(257);
var react_hot_loader_default = /*#__PURE__*/__webpack_require__.n(react_hot_loader);

// EXTERNAL MODULE: ./node_modules/react-router-dom/esm/react-router-dom.js + 6 modules
var react_router_dom = __webpack_require__(59);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 15 modules
var es = __webpack_require__(32);

// EXTERNAL MODULE: ./node_modules/normalizr/dist/normalizr.es.js
var normalizr_es = __webpack_require__(274);

// CONCATENATED MODULE: ./src/store/schema.js


var eventSchema = new normalizr_es["a" /* schema */].Entity('events');
// EXTERNAL MODULE: ./src/store/configureStore.js
var configureStore = __webpack_require__(275);
var configureStore_default = /*#__PURE__*/__webpack_require__.n(configureStore);

// CONCATENATED MODULE: ./src/store/index.js


// EXTERNAL MODULE: ./node_modules/react-loadable/lib/index.js
var lib = __webpack_require__(286);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/semantic-ui-react/dist/es/index.js + 271 modules
var dist_es = __webpack_require__(83);

// CONCATENATED MODULE: ./src/app/components/features/share/loadingInline.js



var loadingInline_LoaderExampleInlineCentered = function LoaderExampleInlineCentered() {
    return react_default.a.createElement(
        dist_es["k" /* Loader */],
        { active: true, inline: 'centered', size: 'large' },
        'Loading'
    );
};

/* harmony default export */ var loadingInline = (loadingInline_LoaderExampleInlineCentered);
// CONCATENATED MODULE: ./src/app/components/features/share/loadable/loadableRoute.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var loadableRoute_Loading = function Loading() {
    return react_default.a.createElement(
        'div',
        { className: 'module loadableRoute' },
        react_default.a.createElement(loadingInline, null)
    );
};

/* harmony default export */ var loadableRoute = (function (opts) {
    return lib_default()(_extends({
        loading: loadableRoute_Loading
    }, opts));
});
// EXTERNAL MODULE: ./src/lib/index.js + 2 modules
var src_lib = __webpack_require__(246);

// CONCATENATED MODULE: ./src/app/routes/routePermission.js
var routePermission__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var Auth = {
    isAuthenticated: function isAuthenticated() {
        var cookies = Object(src_lib["i" /* getAllCookies */])();
        var isAuth = false;

        if (cookies && cookies[src_lib["e" /* TOKEN */]] && cookies[src_lib["f" /* USER_ID */]]) {
            isAuth = true;
        }
        return isAuth;
    },
    isDevice: function isDevice() {
        var isAdmin = Object(src_lib["k" /* getDeviceAdmin */])();
        return isAdmin.toString() === 'true';
    },
    isAdmin: function isAdmin() {
        var isAdmin = Object(src_lib["m" /* getIsAdmin */])();
        return isAdmin.toString() === 'true';
    }
};

var routePermission_AdminPrivateRoute = function AdminPrivateRoute(_ref) {
    var Component = _ref.component,
        Layout = _ref.layout,
        staticContext = _ref.staticContext,
        rest = _objectWithoutProperties(_ref, ['component', 'layout', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === true && Auth.isAdmin() === false && props.match.url !== '/login') {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/unauthen' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
                }
            }
        }
    }));
};

var routePermission_DeviceRoute = function DeviceRoute(_ref2) {
    var Component = _ref2.component,
        Layout = _ref2.layout,
        onGoingJob = _ref2.onGoingJob,
        staticContext = _ref2.staticContext,
        rest = _objectWithoutProperties(_ref2, ['component', 'layout', 'onGoingJob', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === true && Auth.isDevice() === false && props.match.url !== '/deviceLogin') {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/unauthen' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                console.log(3);
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/pdOnGoingJob' });
                }
            }
        }
    }));
};

var routePermission_PrivateRoute = function PrivateRoute(_ref3) {
    var Component = _ref3.component,
        Layout = _ref3.layout,
        staticContext = _ref3.staticContext,
        rest = _objectWithoutProperties(_ref3, ['component', 'layout', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === false && props.match.url !== '/login') {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/login' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
                }
            }
        }
    }));
};

var routePermission_PublicRoute = function PublicRoute(_ref4) {
    var Component = _ref4.component,
        Layout = _ref4.layout,
        onGoingJob = _ref4.onGoingJob,
        staticContext = _ref4.staticContext,
        rest = _objectWithoutProperties(_ref4, ['component', 'layout', 'onGoingJob', 'staticContext']);

    return react_default.a.createElement(react_router_dom["c" /* Route */], routePermission__extends({}, rest, {
        render: function render(props) {
            if (Auth.isAuthenticated() === true && props.match.url === '/login') {
                return react_default.a.createElement(react_router_dom["b" /* Redirect */], { to: '/' });
            }

            if (Layout) {
                return react_default.a.createElement(Layout, routePermission__extends({}, props, { Component: Component }));
            } else {
                if (Component !== undefined) {
                    return react_default.a.createElement(Component, props);
                } else {
                    return null;
                }
            }
        }
    }));
};


// CONCATENATED MODULE: ./src/app/routes/Routes.js





//Layout
var LayoutMaster = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 732));
    }
});
var LayoutBlank = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 733));
    }
});
var LayoutPD = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 734));
    }
});
var LayoutLogin = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 735));
    }
});

//Features
//Auth
var NotFoundController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 736));
    }
});
var UnAuthenController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 737));
    }
});

// Home

var LoginController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 738));
    }
});

var AmthLoginController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 739));
    }
});

var LoginManageDomainController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 740));
    }
});
// Domain
var DomainController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 741));
    }
});
var DomainCreateController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 742));
    }
});
var DomainUpdateController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 743));
    }
});
var DomainViewController = loadableRoute({
    loader: function loader() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 744));
    }
});

/* harmony default export */ var Routes = (function () {
    return react_default.a.createElement(
        react_router_dom["d" /* Switch */],
        null,
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/domain/create', component: DomainCreateController, layout: LayoutBlank, onGoingJob: true }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/domain/update/:id', component: DomainUpdateController, layout: LayoutBlank, onGoingJob: true }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/domain/view/:id', component: DomainViewController, layout: LayoutBlank, onGoingJob: true }),
        react_default.a.createElement(routePermission_PrivateRoute, { path: '/domain/list', component: DomainController, layout: LayoutBlank }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/amth/:redirectUrl', component: AmthLoginController, layout: LayoutLogin }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/amth', component: AmthLoginController, layout: LayoutLogin }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/login', component: LoginController, layout: LayoutLogin }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/manageDomainLogin', component: LoginManageDomainController, layout: LayoutLogin }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/unauthen', component: UnAuthenController, layout: LayoutLogin }),
        react_default.a.createElement(routePermission_PublicRoute, { path: '/', component: LoginManageDomainController, layout: LayoutLogin }),
        react_default.a.createElement(routePermission_PublicRoute, { component: NotFoundController, layout: LayoutMaster })
    );
});
// CONCATENATED MODULE: ./src/app/routes/App.js



/* harmony default export */ var App = (function () {
  return react_default.a.createElement(Routes, null);
});
// EXTERNAL MODULE: ./node_modules/recompose/es/Recompose.js
var Recompose = __webpack_require__(154);

// EXTERNAL MODULE: ./src/app/redux/types.js
var types = __webpack_require__(41);

// CONCATENATED MODULE: ./src/app/redux/actions/actionsCallAPI.js
var actionsCallAPI__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// import { CALL_API } from 'Middlewares'


function actionsCallAPI_setError(errorList, newError, isShow) {
    var mapError = [];
    if (errorList && Array.isArray(errorList)) {
        if (isShow === true) {
            errorList.forEach(function (e) {
                mapError.push(actionsCallAPI__extends({}, e, { isShow: true }));
            });
        } else {
            mapError = mapError.concat(errorList);
        }
    }
    if (newError) {
        mapError.push(actionsCallAPI__extends({}, newError, { isShow: false }));
    }
    console.log(mapError);
    return {
        type: types["_22" /* SET_ERROR */],
        error: mapError
    };
}

function actionsCallAPI_setLoading(isLoading) {
    return {
        type: types["_23" /* SET_LOADING */],
        isLoading: isLoading
    };
}
// EXTERNAL MODULE: ./src/app/redux/selectors/selectorCallAPI.js
var selectorCallAPI = __webpack_require__(156);

// EXTERNAL MODULE: ./src/app/components/features/config.js
var config = __webpack_require__(250);

// CONCATENATED MODULE: ./src/app/components/features/share/modal/actionModal.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var actionModal_ActionModal = function (_React$Component) {
    _inherits(ActionModal, _React$Component);

    function ActionModal(props) {
        _classCallCheck(this, ActionModal);

        var _this = _possibleConstructorReturn(this, (ActionModal.__proto__ || Object.getPrototypeOf(ActionModal)).call(this, props));

        _this.state = {
            open: false
        };
        return _this;
    }

    _createClass(ActionModal, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                open = _props.open,
                type = _props.type,
                header = _props.header,
                detail = _props.detail,
                typeAction = _props.typeAction,
                close = _props.close,
                submit = _props.submit,
                cancelButtonName = _props.cancelButtonName;


            var _type = 'question',
                _header = '',
                _detail = '',
                classModal = '';

            if (type) {
                _type = type;
            }

            _header = header;
            _detail = detail;

            switch (_type) {
                case 'question':
                    classModal = 'question';
                    break;
                case 'warning':
                    classModal = 'warning';
                    break;
                case 'danger':
                    classModal = 'danger';
                    break;
                case 'detail':
                    classModal = 'detail';
                    break;
                default:
                    break;
            }

            return react_default.a.createElement(
                react_default.a.Fragment,
                null,
                react_default.a.createElement(
                    dist_es["l" /* Modal */],
                    { open: open, onClose: close, size: classModal !== 'detail' ? 'tiny' : 'large', className: 'module actionModal' },
                    react_default.a.createElement(
                        dist_es["l" /* Modal */].Header,
                        { className: 'headerBG ' + classModal },
                        react_default.a.createElement(
                            dist_es["e" /* Grid */],
                            null,
                            react_default.a.createElement(
                                dist_es["e" /* Grid */].Row,
                                null,
                                react_default.a.createElement(
                                    dist_es["e" /* Grid */].Column,
                                    { width: 16, className: 'inlineFlex' },
                                    react_default.a.createElement(
                                        'div',
                                        { className: 'boxHeaderContent' },
                                        react_default.a.createElement(
                                            'div',
                                            { className: 'boxImageClose', onClick: this.props.close },
                                            react_default.a.createElement('img', { src: config["b" /* iconCloseModalError */], alt: '' })
                                        )
                                    ),
                                    classModal !== 'detail' && react_default.a.createElement(
                                        'div',
                                        { className: 'boxImageLogo' },
                                        react_default.a.createElement('img', { src: config["c" /* iconLogoModalError */], alt: '', className: 'imgIcon' })
                                    ),
                                    react_default.a.createElement(
                                        'div',
                                        { className: 'boxTextHeader ' + classModal },
                                        react_default.a.createElement(
                                            'p',
                                            { className: 'dialogHeader ' + (classModal !== 'detail' ? ' padLeft20' : '') },
                                            _header
                                        )
                                    )
                                )
                            )
                        )
                    ),
                    react_default.a.createElement(
                        dist_es["l" /* Modal */].Content,
                        null,
                        react_default.a.createElement(
                            dist_es["l" /* Modal */].Description,
                            null,
                            react_default.a.createElement(
                                dist_es["e" /* Grid */],
                                null,
                                react_default.a.createElement(
                                    dist_es["e" /* Grid */].Row,
                                    null,
                                    react_default.a.createElement(
                                        dist_es["e" /* Grid */].Column,
                                        { width: 16 },
                                        react_default.a.createElement(
                                            'div',
                                            { className: 'boxTextDetail' },
                                            react_default.a.createElement(
                                                'p',
                                                null,
                                                _detail
                                            ),
                                            react_default.a.createElement('div', { className: 'boxAction' })
                                        )
                                    )
                                ),
                                react_default.a.createElement(
                                    dist_es["e" /* Grid */].Row,
                                    null,
                                    react_default.a.createElement(
                                        dist_es["e" /* Grid */].Column,
                                        { textAlign: 'center' },
                                        react_default.a.createElement(
                                            dist_es["a" /* Button */],
                                            { className: 'btn cancel', onClick: close },
                                            cancelButtonName ? cancelButtonName : 'Cancel'
                                        ),
                                        typeAction === 'delete' && react_default.a.createElement(
                                            dist_es["a" /* Button */],
                                            { className: 'btn delete', onClick: submit },
                                            'Delete'
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return ActionModal;
}(react_default.a.Component);

/* harmony default export */ var actionModal = (actionModal_ActionModal);
// EXTERNAL MODULE: ./node_modules/react-switch-lang/index.js
var react_switch_lang = __webpack_require__(121);
var react_switch_lang_default = /*#__PURE__*/__webpack_require__.n(react_switch_lang);

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(530);

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(249);
var ReactToastify_default = /*#__PURE__*/__webpack_require__.n(ReactToastify);

// CONCATENATED MODULE: ./src/app/components/features/share/modal/errorModal.js
var errorModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function errorModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function errorModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function errorModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// import { iconCloseModalError, iconLogoModalError } from '../../config'





var errorModal_ErrorModal = function (_React$Component) {
    errorModal__inherits(ErrorModal, _React$Component);

    function ErrorModal(props) {
        errorModal__classCallCheck(this, ErrorModal);

        var _this = errorModal__possibleConstructorReturn(this, (ErrorModal.__proto__ || Object.getPrototypeOf(ErrorModal)).call(this, props));

        _this.state = {};
        return _this;
    }

    errorModal__createClass(ErrorModal, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                errorList = _props.errorList,
                t = _props.t;


            return react_default.a.createElement(
                react_default.a.Fragment,
                null,
                react_default.a.createElement(react_toastify_esm["a" /* ToastContainer */], {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    newestOnTop: false,
                    closeOnClick: true,
                    rtl: false,
                    pauseOnFocusLoss: true,
                    draggable: true,
                    pauseOnHover: true
                }),
                errorList.length > 0 && react_toastify_esm["b" /* toast */].error(react_default.a.createElement(
                    react_default.a.Fragment,
                    null,
                    react_default.a.createElement(
                        'p',
                        { style: { fontWeight: 'bold', color: 'white', fontSize: '1em' } },
                        t('common.somethingWrong')
                    ),
                    errorList.map(function (e, i) {
                        var message = e.message,
                            path = e.path,
                            code = e.code;

                        var data = { statusText: message, statusCode: path, code: code };
                        return react_default.a.createElement(errorModal_ItemErrorObj, { key: i, data: data });
                    })
                ), {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    onClose: function onClose() {
                        return _this2.props.setError(null, null, true);
                    }
                })
            );
        }
    }]);

    return ErrorModal;
}(react_default.a.Component);

var errorModal_ItemErrorObj = function ItemErrorObj(props) {
    var data = props.data;


    return react_default.a.createElement(
        dist_es["j" /* List */].Item,
        { className: 'itemError' },
        react_default.a.createElement(
            dist_es["j" /* List */].Content,
            null,
            data.code && react_default.a.createElement(
                'p',
                { style: { color: 'white', fontSize: '0.9em' } },
                data.code
            ),
            react_default.a.createElement(
                'p',
                { style: { color: 'white', fontSize: '0.9em' }, className: 'detailError header' },
                data.statusText
            )
        )
    );
};

/* harmony default export */ var errorModal = (Object(Recompose["a" /* compose */])(react_router_dom["e" /* withRouter */], react_switch_lang["translate"], Object(es["b" /* connect */])(function (state, props) {
    return {
        errorList: Object(selectorCallAPI["a" /* getErrorList */])(state)
    };
}, function (dispatch, _ref) {
    var history = _ref.history;
    return {
        setError: function setError(errorList, newError, isShow) {
            dispatch(actionsCallAPI_setError(errorList, newError, isShow));
        }
    };
}), Object(Recompose["b" /* lifecycle */])({}))(errorModal_ErrorModal));
// CONCATENATED MODULE: ./src/app/components/features/share/loading.js




var loading_Loading = function Loading(props) {
    var active = props && props.isActive ? props.isActive : false;

    return react_default.a.createElement(
        dist_es["c" /* Dimmer */],
        { style: { position: 'fixed' }, active: active },
        react_default.a.createElement(loadingInline, null)
    );
};

/* harmony default export */ var share_loading = (loading_Loading);
// CONCATENATED MODULE: ./src/app/components/features/share/modal/loadingModal.js
var loadingModal__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function loadingModal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function loadingModal__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function loadingModal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var loadingModal_LoadingModal = function (_React$Component) {
    loadingModal__inherits(LoadingModal, _React$Component);

    function LoadingModal(props) {
        loadingModal__classCallCheck(this, LoadingModal);

        var _this = loadingModal__possibleConstructorReturn(this, (LoadingModal.__proto__ || Object.getPrototypeOf(LoadingModal)).call(this, props));

        _this.state = {
            isLoading: false
        };
        return _this;
    }

    loadingModal__createClass(LoadingModal, [{
        key: 'render',
        value: function render() {
            var loading = this.props.loading;


            return react_default.a.createElement(share_loading, { isActive: loading });
        }
    }]);

    return LoadingModal;
}(react_default.a.Component);

/* harmony default export */ var loadingModal = (Object(Recompose["a" /* compose */])(react_router_dom["e" /* withRouter */], react_switch_lang["translate"], Object(es["b" /* connect */])(function (state, props) {
    return {
        loading: Object(selectorCallAPI["b" /* getLoading */])(state)
    };
}, function (dispatch, _ref) {
    var history = _ref.history;
    return {
        setLoading: function setLoading(isLoading) {
            dispatch(actionsCallAPI_setLoading(isLoading));
        }
    };
}), Object(Recompose["b" /* lifecycle */])({}))(loadingModal_LoadingModal));
// EXTERNAL MODULE: ./src/app/components/scss/index.scss
var scss = __webpack_require__(531);
var scss_default = /*#__PURE__*/__webpack_require__.n(scss);

// CONCATENATED MODULE: ./src/app/routes/Root.js






// import ErrorBoundary from '../components/features/share/ErrorBoundary'

// import Loading from '../components/features/share/loading'


var store = configureStore_default()();

/* harmony default export */ var Root = (function () {
    return react_default.a.createElement(
        es["a" /* Provider */],
        { store: store },
        react_default.a.createElement(
            react_router_dom["a" /* BrowserRouter */],
            null,
            react_default.a.createElement(
                react_default.a.Fragment,
                null,
                react_default.a.createElement(App, null),
                react_default.a.createElement(errorModal, null),
                react_default.a.createElement(loadingModal, null)
            )
        )
    );
});
// EXTERNAL MODULE: ./src/wording/language/en/common.json
var common = __webpack_require__(539);
var common_default = /*#__PURE__*/__webpack_require__.n(common);

// EXTERNAL MODULE: ./src/wording/language/en/login.json
var login = __webpack_require__(540);
var login_default = /*#__PURE__*/__webpack_require__.n(login);

// EXTERNAL MODULE: ./src/wording/language/en/search.json
var search = __webpack_require__(541);
var search_default = /*#__PURE__*/__webpack_require__.n(search);

// EXTERNAL MODULE: ./src/wording/language/en/header.json
var en_header = __webpack_require__(542);
var header_default = /*#__PURE__*/__webpack_require__.n(en_header);

// EXTERNAL MODULE: ./src/wording/language/en/button.json
var en_button = __webpack_require__(543);
var button_default = /*#__PURE__*/__webpack_require__.n(en_button);

// EXTERNAL MODULE: ./src/wording/language/en/home.json
var home = __webpack_require__(544);
var home_default = /*#__PURE__*/__webpack_require__.n(home);

// EXTERNAL MODULE: ./src/wording/language/en/menu.json
var menu = __webpack_require__(545);
var menu_default = /*#__PURE__*/__webpack_require__.n(menu);

// EXTERNAL MODULE: ./src/wording/language/en/share.json
var share = __webpack_require__(546);
var share_default = /*#__PURE__*/__webpack_require__.n(share);

// EXTERNAL MODULE: ./src/wording/language/en/user.json
var user = __webpack_require__(547);
var user_default = /*#__PURE__*/__webpack_require__.n(user);

// EXTERNAL MODULE: ./src/wording/language/en/master.json
var master = __webpack_require__(548);
var master_default = /*#__PURE__*/__webpack_require__.n(master);

// EXTERNAL MODULE: ./src/wording/language/en/warehouse.json
var warehouse = __webpack_require__(549);
var warehouse_default = /*#__PURE__*/__webpack_require__.n(warehouse);

// EXTERNAL MODULE: ./src/wording/language/en/display.json
var display = __webpack_require__(550);
var display_default = /*#__PURE__*/__webpack_require__.n(display);

// CONCATENATED MODULE: ./src/wording/language/en.js
var en__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














/* harmony default export */ var en = (en__extends({}, common_default.a, login_default.a, search_default.a, header_default.a, button_default.a, home_default.a, menu_default.a, share_default.a, user_default.a, master_default.a, warehouse_default.a, display_default.a));
// EXTERNAL MODULE: ./src/wording/language/th/common.json
var th_common = __webpack_require__(551);
var th_common_default = /*#__PURE__*/__webpack_require__.n(th_common);

// EXTERNAL MODULE: ./src/wording/language/th/login.json
var th_login = __webpack_require__(552);
var th_login_default = /*#__PURE__*/__webpack_require__.n(th_login);

// EXTERNAL MODULE: ./src/wording/language/th/search.json
var th_search = __webpack_require__(245);
var th_search_default = /*#__PURE__*/__webpack_require__.n(th_search);

// EXTERNAL MODULE: ./src/wording/language/th/button.json
var th_button = __webpack_require__(553);
var th_button_default = /*#__PURE__*/__webpack_require__.n(th_button);

// EXTERNAL MODULE: ./src/wording/language/th/home.json
var th_home = __webpack_require__(554);
var th_home_default = /*#__PURE__*/__webpack_require__.n(th_home);

// EXTERNAL MODULE: ./src/wording/language/th/menu.json
var th_menu = __webpack_require__(555);
var th_menu_default = /*#__PURE__*/__webpack_require__.n(th_menu);

// EXTERNAL MODULE: ./src/wording/language/th/share.json
var th_share = __webpack_require__(556);
var th_share_default = /*#__PURE__*/__webpack_require__.n(th_share);

// EXTERNAL MODULE: ./src/wording/language/th/user.json
var th_user = __webpack_require__(557);
var th_user_default = /*#__PURE__*/__webpack_require__.n(th_user);

// EXTERNAL MODULE: ./src/wording/language/th/master.json
var th_master = __webpack_require__(558);
var th_master_default = /*#__PURE__*/__webpack_require__.n(th_master);

// EXTERNAL MODULE: ./src/wording/language/th/warehouse.json
var th_warehouse = __webpack_require__(559);
var th_warehouse_default = /*#__PURE__*/__webpack_require__.n(th_warehouse);

// EXTERNAL MODULE: ./src/wording/language/th/display.json
var th_display = __webpack_require__(560);
var th_display_default = /*#__PURE__*/__webpack_require__.n(th_display);

// CONCATENATED MODULE: ./src/wording/language/th.js
var th__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };














/* harmony default export */ var th = (th__extends({}, th_common_default.a, th_login_default.a, th_search_default.a, th_search_default.a, th_button_default.a, th_home_default.a, th_menu_default.a, th_share_default.a, th_user_default.a, th_master_default.a, th_warehouse_default.a, th_display_default.a));
// CONCATENATED MODULE: ./src/index.js










Object(react_switch_lang["setTranslations"])({ en: en, th: th });

Object(react_switch_lang["setDefaultLanguage"])('en');

if (Object(react_switch_lang["getLanguage"])() === 'th' || Object(react_switch_lang["getLanguage"])() === 'en') {
    Object(react_switch_lang["setLanguage"])(Object(react_switch_lang["getLanguage"])());
}

Object(react_switch_lang["setLanguageCookie"])('language', { maxAge: 86400 }, undefined);

var src_render = function render(Component) {
    react_dom_default.a.render(react_default.a.createElement(
        react_hot_loader["AppContainer"],
        null,
        react_default.a.createElement(Component, null)
    ), document.getElementById('root'));
};

src_render(Root);

if (false) {
    module.hot.accept('./app/routes/Root', function () {
        return src_render(RootContainer);
    });
}

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
    module.exports = __webpack_require__(276);
} else {
    module.exports = require('./configureStore.dev');
}

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(61);

// EXTERNAL MODULE: ./node_modules/redux-thunk/es/index.js
var redux_thunk_es = __webpack_require__(277);

// EXTERNAL MODULE: ./src/middlewares/index.js + 3 modules
var src_middlewares = __webpack_require__(247);

// EXTERNAL MODULE: ./node_modules/redux-form/es/index.js + 229 modules
var redux_form_es = __webpack_require__(280);

// CONCATENATED MODULE: ./src/app/redux/reducers/reducerAuth.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var reducerAuth_initialState = {
    user: null
};

/* harmony default export */ var reducerAuth = ({
    authen: function authen() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : reducerAuth_initialState;
        var action = arguments[1];

        switch (action.type) {
            default:
                return _extends({}, state);
        }
    }
});
// EXTERNAL MODULE: ./src/app/redux/types.js
var types = __webpack_require__(41);

// CONCATENATED MODULE: ./src/app/redux/reducers/reducerCallAPI.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var initialStateCallAPI = {
    isLoading: false,

    hasError: false,
    errorMessage: '',
    errorCode: '',
    statusText: ''
},
    initialStateArray = [];

/* harmony default export */ var reducerCallAPI = ({
    errorList: function errorList() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStateArray;
        var action = arguments[1];

        switch (action.type) {
            case types["_22" /* SET_ERROR */]:
                var newError = [];
                if (action && Array.isArray(action.error)) {
                    newError = action.error;
                }
                return newError;

            case types["d" /* CORE_AUTH_VERIFY_SUCCESS */]:
            case types["CORE_MANAGER_VERIFY_SUCCESS"]:
            case types["CORE_CREATE_DEVICE_SUCCESS"]:
            case types["CORE_UPDATE_DEVICE_SUCCESS"]:
            case types["CORE_AUTH_VERIFY_PD_DEVICE_SUCCESS"]:
            case types["i" /* CORE_CREATE_DOMAIN_SUCCESS */]:
            case types["_20" /* CORE_UPDATE_DOMAIN_SUCCESS */]:
                if (action && !Array.isArray(action.payload) && _typeof(action.payload) === 'object') {
                    var _action$payload = action.payload,
                        errors = _action$payload.errors,
                        result = _action$payload.result;
                    var url = action.url;

                    var _newError = [];
                    if (!result) {
                        if (Array.isArray(errors)) {
                            errors.map(function (e) {
                                var path = e.path,
                                    code = e.code,
                                    message = e.message;

                                return _newError.push({ code: code, message: message, isShow: true, path: path, url: url, isFromAction: true });
                            });
                        } else _newError.push({ code: 'unknow', message: 'Some thing went wrong', isShow: true, path: '', url: url, isFromAction: true });
                    }

                    return _newError;
                }
                return state;

            case types["a" /* CORE_AUTH_VERIFY_FAILURE */]:
            case types["CORE_MANAGER_VERIFY_FAILURE"]:
            case types["CORE_CREATE_DEVICE_FAILURE"]:
            case types["CORE_UPDATE_DEVICE_FAILURE"]:
            case types["CORE_AUTH_VERIFY_PD_DEVICE_FAILURE"]:
            case types["g" /* CORE_CREATE_DOMAIN_FAILURE */]:
            case types["_18" /* CORE_UPDATE_DOMAIN_FAILURE */]:
                if (action && !Array.isArray(action.payload) && _typeof(action.payload) === 'object') {
                    var _action$payload2 = action.payload,
                        code = _action$payload2.code,
                        message = _action$payload2.message,
                        statusText = _action$payload2.statusText,
                        statusCode = _action$payload2.statusCode;
                    var _url = action.url;

                    var _newError2 = [];

                    _newError2.push({
                        code: code ? code : '404',
                        message: message,
                        isShow: false,
                        statusText: statusText,
                        statusCode: statusCode,
                        url: _url
                    });

                    return _newError2;
                }
                return state;
            default:
                return state;
        }
    },
    isLoading: function isLoading() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var action = arguments[1];

        switch (action.type) {
            // case CORE_GET_TRANSFER_BY_ID_REQUEST:
            case types["CORE_GET_ALL_DEVICE_REQUEST"]:
            case types["CORE_GET_DEVICE_REQUEST"]:
            case types["CORE_SET_WORKER_REQUEST"]:
            case types["CORE_SET_START_TIME_REQUEST"]:
            case types["CORE_SET_END_TIME_REQUEST"]:
            case types["CORE_TASK_ON_JOB_REQUEST"]:
            case types["CORE_REPORT_AS_FINISHED_DATAS_REQUEST"]:
            case types["CORE_LOAD_RESOURCES_REQUEST"]:
            case types["CORE_LOAD_WAREHOUSES_REQUEST"]:
            case types["CORE_LOAD_SCRAPS_REQUEST"]:
            case types["CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_REQUEST"]:
            case types["CORE_GET_DEVICE_INFO_REQUEST"]:
            case types["C" /* CORE_GET_DOMAIN_ID_REQUEST */]:
            case types["n" /* CORE_GET_ALL_DOMAIN_REQUEST */]:
                return true;
            // case CORE_GET_TRANSFER_BY_ID_SUCCESS:
            case types["CORE_GET_ALL_DEVICE_SUCCESS"]:
            case types["CORE_GET_DEVICE_SUCCESS"]:
            case types["CORE_SET_WORKER_SUCCESS"]:
            case types["CORE_SET_START_TIME_SUCCESS"]:
            case types["CORE_SET_END_TIME_SUCCESS"]:
            case types["CORE_TASK_ON_JOB_SUCCESS"]:
            case types["CORE_REPORT_AS_FINISHED_DATAS_SUCCESS"]:
            case types["CORE_LOAD_RESOURCES_SUCCESS"]:
            case types["CORE_LOAD_WAREHOUSES_SUCCESS"]:
            case types["CORE_LOAD_SCRAPS_SUCCESS"]:
            case types["CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_SUCCESS"]:
            case types["CORE_GET_DEVICE_INFO_SUCCESS"]:
            case types["D" /* CORE_GET_DOMAIN_ID_SUCCESS */]:
            case types["o" /* CORE_GET_ALL_DOMAIN_SUCCESS */]:
                return false;
            // case CORE_GET_TRANSFER_BY_ID_FAILURE:
            case types["CORE_GET_ALL_DEVICE_FAILURE"]:
            case types["CORE_GET_DEVICE_FAILURE"]:
            case types["CORE_SET_WORKER_FAILURE"]:
            case types["CORE_SET_START_TIME_FAILURE"]:
            case types["CORE_SET_END_TIME_FAILURE"]:
            case types["CORE_TASK_ON_JOB_FAILURE"]:
            case types["CORE_REPORT_AS_FINISHED_DATAS_FAILURE"]:
            case types["CORE_LOAD_RESOURCES_FAILURE"]:
            case types["CORE_LOAD_WAREHOUSES_FAILURE"]:
            case types["CORE_LOAD_SCRAPS_FAILURE"]:
            case types["CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_FAILURE"]:
            case types["CORE_GET_DEVICE_INFO_FAILURE"]:
            case types["B" /* CORE_GET_DOMAIN_ID_FAILURE */]:
            case types["m" /* CORE_GET_ALL_DOMAIN_FAILURE */]:
                return false;
            default:
                return state;
        }
    },
    reducerCallAPI: function reducerCallAPI() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialStateCallAPI;
        var action = arguments[1];

        switch (action.type) {
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/user.js
var user__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


var requestState = types["_21" /* REQUEST_STATE */];

/* harmony default export */ var reducers_user = ({
    user: function user() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["L" /* CORE_GET_USER_INFO_REQUEST */]:
                return state;
            case types["M" /* CORE_GET_USER_INFO_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && user__typeof(action.payload) === 'object') {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        data = _action$payload.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["K" /* CORE_GET_USER_INFO_FAILURE */]:
                return {};
            default:
                return state;
        }
    },
    users: function users() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["I" /* CORE_GET_USERS_REQUEST */]:
                return state;
            case types["J" /* CORE_GET_USERS_SUCCESS */]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        datas = _action$payload2.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["H" /* CORE_GET_USERS_FAILURE */]:
                return [];
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/axData.js



var axData_requestState = types["_21" /* REQUEST_STATE */];

/* harmony default export */ var axData = ({
    resources: function resources() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : axData_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["CORE_LOAD_RESOURCES_REQUEST"]:
                return state;
            case types["CORE_LOAD_RESOURCES_SUCCESS"]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["CORE_LOAD_RESOURCES_FAILURE"]:
                return [];
            default:
                return state;
        }
    },

    warehouses: function warehouses() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : axData_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["CORE_LOAD_WAREHOUSES_REQUEST"]:
                return state;
            case types["CORE_LOAD_WAREHOUSES_SUCCESS"]:
                if (action.payload) {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        datas = _action$payload2.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["CORE_LOAD_WAREHOUSES_FAILURE"]:
                return [];
            default:
                return state;
        }
    },

    scraps: function scraps() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : axData_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["CORE_LOAD_SCRAPS_REQUEST"]:
                return state;
            case types["CORE_LOAD_SCRAPS_SUCCESS"]:
                if (action.payload) {
                    var _action$payload3 = action.payload,
                        result = _action$payload3.result,
                        datas = _action$payload3.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["CORE_LOAD_SCRAPS_FAILURE"]:
                return [];
            default:
                return state;
        }
    },

    materials: function materials() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : axData_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_REQUEST"]:
                return state;
            case types["CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_SUCCESS"]:
                if (action.payload) {
                    var _action$payload4 = action.payload,
                        result = _action$payload4.result,
                        datas = _action$payload4.datas;

                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case types["CORE_LOAD_MATERIALS_BY_WAREHOUSE_ID_FAILURE"]:
                return [];
            default:
                return state;
        }
    }

    // masterStation: (state = requestState, action) => {
    //     switch (action.type) {
    //         case CORE_LOAD_MASTER_DATA_STATION_REQUEST:
    //             return state
    //         case CORE_LOAD_MASTER_DATA_STATION_SUCCESS:
    //             if (action.payload) {
    //                 const { result, data } = action.payload
    //                 if (result && data) {
    //                     return data
    //                 } else return {}
    //             } else {
    //                 return {}
    //             }
    //         case CORE_LOAD_MASTER_DATA_STATION_FAILURE:
    //             return {}
    //         default:
    //             return state
    //     }
    // },
});
// CONCATENATED MODULE: ./src/app/redux/reducers/display.js
var display__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var display_requestState = types["_21" /* REQUEST_STATE */];

/* harmony default export */ var display = ({
    getTables: function getTables() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : display_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["CORE_GET_ALL_TABLE_REQUEST"]:
                return state;
            case types["CORE_GET_ALL_TABLE_SUCCESS"]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["CORE_GET_ALL_TABLE_FAILURE"]:
                return [];
            default:
                return state;
        }
    },
    getTable: function getTable() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : display_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["CORE_GET_TABLE_BY_ID_REQUEST"]:
                return state;
            case types["CORE_GET_TABLE_BY_ID_SUCCESS"]:
                if (action.payload && !Array.isArray(action.payload) && display__typeof(action.payload) === 'object') {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["CORE_GET_TABLE_BY_ID_FAILURE"]:
                return {};
            default:
                return state;
        }
    },
    pdsmAxData: function pdsmAxData() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : display_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["CORE_TASK_ON_JOB_REQUEST"]:
                return state;
            case types["CORE_TASK_ON_JOB_SUCCESS"]:
                if (action.payload && !Array.isArray(action.payload) && display__typeof(action.payload) === 'object') {
                    var _action$payload3 = action.payload,
                        result = _action$payload3.result,
                        data = _action$payload3.data;

                    console.log(action.payload);
                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["CORE_TASK_ON_JOB_FAILURE"]:
                return {};
            default:
                return state;
        }
    },
    setStartTime: function setStartTime() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : display_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["CORE_SET_START_TIME_REQUEST"]:
                return state;
            case types["CORE_SET_START_TIME_SUCCESS"]:
                if (action.payload && !Array.isArray(action.payload) && display__typeof(action.payload) === 'object') {
                    var _action$payload4 = action.payload,
                        result = _action$payload4.result,
                        data = _action$payload4.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["CORE_SET_START_TIME_FAILURE"]:
                return {};
            default:
                return state;
        }
    },
    setEndTime: function setEndTime() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : display_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["CORE_SET_END_TIME_REQUEST"]:
                return state;
            case types["CORE_SET_END_TIME_SUCCESS"]:
                if (action.payload && !Array.isArray(action.payload) && display__typeof(action.payload) === 'object') {
                    var _action$payload5 = action.payload,
                        result = _action$payload5.result,
                        data = _action$payload5.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["CORE_SET_END_TIME_FAILURE"]:
                return {};
            default:
                return state;
        }
    },
    setWorker: function setWorker() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : display_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["CORE_SET_WORKER_REQUEST"]:
                return state;
            case types["CORE_SET_WORKER_SUCCESS"]:
                if (action.payload && !Array.isArray(action.payload) && display__typeof(action.payload) === 'object') {
                    var _action$payload6 = action.payload,
                        result = _action$payload6.result,
                        data = _action$payload6.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["CORE_SET_WORKER_FAILURE"]:
                return {};
            default:
                return state;
        }
    },
    reportFinishData: function reportFinishData() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : display_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["CORE_REPORT_AS_FINISHED_DATAS_REQUEST"]:
                return state;
            case types["CORE_REPORT_AS_FINISHED_DATAS_SUCCESS"]:
                if (action.payload) {
                    var _action$payload7 = action.payload,
                        result = _action$payload7.result,
                        datas = _action$payload7.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["CORE_REPORT_AS_FINISHED_DATAS_FAILURE"]:
                return [];
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers/domain.js
var domain__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var domain_requestState = types["_21" /* REQUEST_STATE */];

/* harmony default export */ var domain = ({
    allDomain: function allDomain() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : domain_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["n" /* CORE_GET_ALL_DOMAIN_REQUEST */]:
                return state;
            case types["o" /* CORE_GET_ALL_DOMAIN_SUCCESS */]:
                if (action.payload) {
                    var _action$payload = action.payload,
                        result = _action$payload.result,
                        datas = _action$payload.datas;

                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case types["m" /* CORE_GET_ALL_DOMAIN_FAILURE */]:
                return [];
            default:
                return state;
        }
    },
    domainById: function domainById() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : domain_requestState;
        var action = arguments[1];

        switch (action.type) {
            case types["C" /* CORE_GET_DOMAIN_ID_REQUEST */]:
                return state;
            case types["D" /* CORE_GET_DOMAIN_ID_SUCCESS */]:
                if (action.payload && !Array.isArray(action.payload) && domain__typeof(action.payload) === 'object') {
                    var _action$payload2 = action.payload,
                        result = _action$payload2.result,
                        data = _action$payload2.data;

                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case types["B" /* CORE_GET_DOMAIN_ID_FAILURE */]:
                return {};
            default:
                return state;
        }
    }
});
// CONCATENATED MODULE: ./src/app/redux/reducers.js


// import { reducer as notificationsReducer } from 'reapop'








/* harmony default export */ var reducers = (Object(es["c" /* combineReducers */])({
    form: redux_form_es["a" /* reducer */],
    // notifications: notificationsReducer(),
    authen: reducerAuth.authen,
    users: reducers_user.users,
    user: reducers_user.user,
    callAPI: reducerCallAPI.reducerCallAPI,
    errorList: reducerCallAPI.errorList, //Error list from API
    isLoading: reducerCallAPI.isLoading,

    resources: axData.resources,
    warehouses: axData.warehouses,
    scraps: axData.scraps,

    materials: axData.materials,

    tablesData: display.getTables,
    tableData: display.getTable,
    pdsmAxData: display.pdsmAxData,
    startTimeData: display.setStartTime,
    endTimeData: display.setEndTime,
    workerData: display.setWorker,
    reportFinishData: display.reportFinishData,

    allDomain: domain.allDomain,
    domainById: domain.domainById
}));
// CONCATENATED MODULE: ./src/store/configureStore.prod.js





/* harmony default export */ var configureStore_prod = __webpack_exports__["default"] = (function (initialState) {
    var middlewares = [src_middlewares["c" /* checkToken */], src_middlewares["d" /* setToken */], src_middlewares["b" /* api */], redux_thunk_es["a" /* default */]];

    var store = Object(es["d" /* createStore */])(reducers, initialState, es["a" /* applyMiddleware */].apply(undefined, middlewares));

    return store;
});

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return REQUEST_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return SET_LOADING; });
/* unused harmony export LOGOUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CORE_GET_USERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CORE_GET_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CORE_GET_USERS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CORE_GET_USER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CORE_GET_USER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CORE_GET_USER_INFO_FAILURE; });
/* unused harmony export CORE_CHANGE_USER_NPI_PERMIT_REQUEST */
/* unused harmony export CORE_CHANGE_USER_NPI_PERMIT_SUCCESS */
/* unused harmony export CORE_CHANGE_USER_NPI_PERMIT_FAILURE */
/* unused harmony export CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST */
/* unused harmony export CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS */
/* unused harmony export CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE */
/* unused harmony export CORE_AUTH_VERIFY_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CORE_AUTH_VERIFY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CORE_AUTH_VERIFY_FAILURE; });
/* unused harmony export CORE_GET_REQUEST_INFO_REQUEST */
/* unused harmony export CORE_GET_REQUEST_INFO_SUCCESS */
/* unused harmony export CORE_GET_REQUEST_INFO_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CORE_GET_ALL_DOMAIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CORE_GET_ALL_DOMAIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CORE_GET_ALL_DOMAIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CORE_CREATE_DOMAIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CORE_CREATE_DOMAIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CORE_CREATE_DOMAIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CORE_GET_DOMAIN_ID_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CORE_GET_DOMAIN_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CORE_GET_DOMAIN_ID_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return CORE_UPDATE_DOMAIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return CORE_UPDATE_DOMAIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return CORE_UPDATE_DOMAIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CORE_GET_CHANGE_EXPIRE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CORE_GET_CHANGE_EXPIRE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CORE_GET_CHANGE_EXPIRE_FAILURE; });
var REQUEST_STATE = 'REQUEST_STATE';
var SET_ERROR = 'SET_ERROR';
var SET_LOADING = 'SET_LOADING';

var LOGOUT = 'LOGOUT';
var CORE_GET_USERS_REQUEST = 'CORE_GET_USERS_REQUEST';
var CORE_GET_USERS_SUCCESS = 'CORE_GET_USERS_SUCCESS';
var CORE_GET_USERS_FAILURE = 'CORE_GET_USERS_FAILURE';

var CORE_GET_USER_INFO_REQUEST = 'CORE_GET_USER_INFO_REQUEST';
var CORE_GET_USER_INFO_SUCCESS = 'CORE_GET_USER_INFO_SUCCESS';
var CORE_GET_USER_INFO_FAILURE = 'CORE_GET_USER_INFO_FAILURE';

var CORE_CHANGE_USER_NPI_PERMIT_REQUEST = 'CORE_CHANGE_USER_NPI_PERMIT_REQUEST';
var CORE_CHANGE_USER_NPI_PERMIT_SUCCESS = 'CORE_CHANGE_USER_NPI_PERMIT_SUCCESS';
var CORE_CHANGE_USER_NPI_PERMIT_FAILURE = 'CORE_CHANGE_USER_NPI_PERMIT_FAILURE';

var CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST = 'CORE_CHANGE_USER_ADMIN_PERMIT_REQUEST';
var CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS = 'CORE_CHANGE_USER_ADMIN_PERMIT_SUCCESS';
var CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE = 'CORE_CHANGE_USER_ADMIN_PERMIT_FAILURE';

//AUTH
var CORE_AUTH_VERIFY_REQUEST = 'CORE_AUTH_VERIFY_REQUEST';
var CORE_AUTH_VERIFY_SUCCESS = 'CORE_AUTH_VERIFY_SUCCESS';
var CORE_AUTH_VERIFY_FAILURE = 'CORE_AUTH_VERIFY_FAILURE';

var CORE_GET_REQUEST_INFO_REQUEST = 'CORE_GET_REQUEST_INFO_REQUEST';
var CORE_GET_REQUEST_INFO_SUCCESS = 'CORE_GET_REQUEST_INFO_SUCCESS';
var CORE_GET_REQUEST_INFO_FAILURE = 'CORE_GET_REQUEST_INFO_FAILURE';

//Domain
var CORE_GET_ALL_DOMAIN_REQUEST = 'CORE_GET_ALL_DOMAIN_REQUEST';
var CORE_GET_ALL_DOMAIN_SUCCESS = 'CORE_GET_ALL_DOMAIN_SUCCESS';
var CORE_GET_ALL_DOMAIN_FAILURE = 'CORE_GET_ALL_DOMAIN_FAILURE';

var CORE_CREATE_DOMAIN_REQUEST = 'CORE_CREATE_DOMAIN_REQUEST';
var CORE_CREATE_DOMAIN_SUCCESS = 'CORE_CREATE_DOMAIN_SUCCESS';
var CORE_CREATE_DOMAIN_FAILURE = 'CORE_CREATE_DOMAIN_FAILURE';

var CORE_GET_DOMAIN_ID_REQUEST = 'CORE_GET_DOMAIN_ID_REQUEST';
var CORE_GET_DOMAIN_ID_SUCCESS = 'CORE_GET_DOMAIN_ID_SUCCESS';
var CORE_GET_DOMAIN_ID_FAILURE = 'CORE_GET_DOMAIN_ID_FAILURE';

var CORE_UPDATE_DOMAIN_REQUEST = 'CORE_UPDATE_DOMAIN_REQUEST';
var CORE_UPDATE_DOMAIN_SUCCESS = 'CORE_UPDATE_DOMAIN_SUCCESS';
var CORE_UPDATE_DOMAIN_FAILURE = 'CORE_UPDATE_DOMAIN_FAILURE';

var CORE_GET_CHANGE_EXPIRE_REQUEST = 'CORE_UPDATE_DOMAIN_REQUEST';
var CORE_GET_CHANGE_EXPIRE_SUCCESS = 'CORE_GET_CHANGE_EXPIRE_SUCCESS';
var CORE_GET_CHANGE_EXPIRE_FAILURE = 'CORE_GET_CHANGE_EXPIRE_FAILURE';

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(532);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(244)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./index.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./index.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(40)(false);
// imports
exports.i(__webpack_require__(533), "");
exports.i(__webpack_require__(534), "");
exports.i(__webpack_require__(535), "");
exports.i(__webpack_require__(536), "");
exports.i(__webpack_require__(537), "");
exports.i(__webpack_require__(538), "");

// module
exports.push([module.i, ".fontMini,.module.errorModal .detailError{font-size:16px;font-size:1.6rem}.btn,.fontBody,.module.errorModal .detailError.detail,.module.inputForm .boxViewValue p,.module.inputForm .labelInput .required,.module.inputForm .labelInput .subject,.module.layoutWithSidebar .menuSidebar,.module.layoutWithSidebar .sidebarBox .actionBox .userBox p,.module.layoutWithSidebar .sidebarBox .headerBox .text p,.module.popupUser .userContent .contentDetail .detailUser .email,.ui.button,p{font-size:18px;font-size:1.8rem;line-height:25px}.fontBodyImportant,.text,.ui.checkbox,.ui.dropdown,.ui.form,.ui.input{font-size:18px!important;font-size:1.8rem!important}.fontHeader,.module.customTable .boxNoData p,.module.errorModal .detailError.header,.module.header .menu-item.text,.module.header .menuMobile,.module.inputForm .headerBoxHeaderTap,.module.itemSettingBox .boxTextHeaderSetting p,.module.menuData .boxMenu .itemMenu p,.module.popupUser .userContent .contentDetail .detailUser .name{font-size:20px!important;font-size:2rem!important}.boxHeaderPage p,.fontHeaderBody,.fontHeaderPage,.module.loginForm .text-box p{font-size:32px;font-size:3.2rem}.fontSettingValueView,.module.itemSettingBox .boxTextValueSetting p{font-size:24px;font-size:2.4rem}.fontStep,.ui.steps .step,.ui.steps .step:first-child,.ui.steps .step:last-child{font-size:16px!important;font-size:1.6rem!important}.btn{font-weight:700!important;min-width:100px}.btnPicker>.ui.basic.button,.btnPicker>.ui.basic.button:active,.btnPicker>.ui.basic.button:hover{background-color:inherit!important;border:none;box-shadow:none!important}.ui.button.btnLogin{background-color:#000;color:#e0e0e0;margin:0;width:9rem;height:9rem;font-size:35px;margin-top:7rem;cursor:pointer}.ui.button.btnAdd{padding:0;width:30px;height:30px;color:#e0e0e0;background-color:#1b2c57;font-size:13px}.ui.button.btnAdd .i.icon,.ui.button.btnAdd i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnAddMinus{padding:0;width:30px;height:30px;color:#0f1a28;background-color:transparent;font-size:13px}.ui.button.btnAddMinus .i.icon,.ui.button.btnAddMinus i.icons{padding-right:2px!important}.ui.button.btnAddMinus.disable{color:#ababab}.btnAddBlueText,.ui.button.btnAddBlueText{padding:0 15px;margin:0;height:40px;border-radius:20px;color:#e0e0e0;background-color:#1e48f9;font-size:16px;min-width:100px;margin-left:5px}.btnAddText,.ui.button.btnAddText{padding:0 15px;height:30px;color:#e0e0e0;background-color:#1b2c57;margin-left:5px!important}.btnAddText.transfer,.btnAddTextInvert.transfer{background-color:#0f1a28;min-width:100px;height:50px!important;width:100%}.btnAddTextInvert,.ui.button.btnAddTextInvert{padding:0 15px;margin:0;height:30px;color:#1b2c57;background-color:#e0e0e0;font-size:13px;min-width:100px;margin-left:5px}.btnAddTextInvert.marginLeft5,.ui.button.btnAddTextInvert.marginLeft5{margin-left:5px!important}.btnAddTextInvert.reportSize,.ui.button.btnAddTextInvert.reportSize{height:100px;min-width:300px;font-size:20px}.btnAddTextInvert.reportSize:focus,.ui.button.btnAddTextInvert.reportSize:focus{-webkit-box-shadow:0 0 6px 5px rgba(255,0,0,.9);box-shadow:0 0 6px 5px rgba(255,0,0,.9)}.btnEditBlueText,.ui.button.btnEditBlueText{padding:0 15px;margin:0;height:30px;color:#e3e4e3;background-color:#1e48f9;font-size:13px;min-width:100px;margin-left:5px}.btnSubmitItemText,.ui.button.btnSubmitItemText{background-color:#f19fff}.btnCancelText,.btnSubmitItemText,.ui.button.btnCancelText,.ui.button.btnSubmitItemText{padding:0 15px;margin:0;height:30px;color:#e0e0e0;font-size:13px;min-width:100px;margin-left:5px}.btnCancelText,.ui.button.btnCancelText{background-color:#d83838}.btnCancelText.marginLeft5,.ui.button.btnCancelText.marginLeft5{margin-left:5px!important}.btnCancelText.reportSize,.ui.button.btnCancelText.reportSize{height:100px;min-width:300px;font-size:20px}.btnCancelEditText,.ui.button.btnCancelEditText{padding:0 15px;margin:0;height:30px;color:#353386;background-color:#e0e0e0;font-size:13px;margin-left:5px;min-width:100px}.btnCancelTextInvert,.ui.button.btnCancelTextInvert{color:#d83838;border:1px solid #d83838}.btnCancelTextInvert,.btnUpdate,.ui.button.btnCancelTextInvert,.ui.button.btnUpdate{padding:0 15px;margin:0;height:30px;background-color:#e3e4e3;font-size:13px;margin-left:5px;min-width:100px}.btnUpdate,.ui.button.btnUpdate{color:#383838;border:1px solid #e0e0e0}.btnAddItemText,.ui.button.btnAddItemText{background-color:#1e48f9}.btnAddItemText,.btnValidateText,.ui.button.btnAddItemText,.ui.button.btnValidateText{padding:0 15px;margin:0;height:30px;color:#e0e0e0;font-size:13px;margin-left:5px;min-width:100px}.btnValidateText,.ui.button.btnValidateText{background-color:#353386}.btnGencodeText,.ui.button.btnGencodeText{background-color:#119303}.btnEditText,.btnGencodeText,.ui.button.btnEditText,.ui.button.btnGencodeText{padding:0 15px;margin:0;height:30px;color:#e0e0e0;font-size:13px;margin-left:5px;min-width:100px}.btnEditText,.ui.button.btnEditText{background-color:#9646ff}.btnEditText.reportSize,.ui.button.btnEditText.reportSize{height:100px;min-width:300px;font-size:20px}.btnEditText.reportSize:focus,.ui.button.btnEditText.reportSize:focus{-webkit-box-shadow:0 0 6px 5px rgba(255,0,0,.9);box-shadow:0 0 6px 5px rgba(255,0,0,.9)}.btnEditYellowText,.ui.button.btnEditYellowText{padding:0 15px;margin:0;height:30px;color:#353386;background-color:#dde01a;font-size:13px;margin-left:5px;min-width:100px}.btnApproveText,.ui.button.btnApproveText{background-color:#119303}.btnApproveText,.btnBackText,.ui.button.btnApproveText,.ui.button.btnBackText{padding:0 15px;margin:0;height:30px;color:#e0e0e0;font-size:13px;margin-left:5px;min-width:100px}.btnBackText,.ui.button.btnBackText{background-color:#f7213b}.ui.button.btnView{padding:0;margin:0;width:30px;height:30px;color:#353386;font-size:13px}.ui.button.btnView .i.icon,.ui.button.btnView i.icons{padding-right:2px!important;color:#353386}.ui.button.btnSearch{padding:0;margin:0;width:30px;height:30px;color:#e0e0e0;background-color:#1b2c57;font-size:13px}.ui.button.btnSearch .i.icon,.ui.button.btnSearch i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnSearchInvert{padding:0;margin:0;width:40px;height:40px;color:#1b2c57;background-color:#e0e0e0;font-size:13px}.ui.button.btnSearchInvert .i.icon,.ui.button.btnSearchInvert i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnReloadData{padding:0;margin:0;width:40px;height:40px;color:#1b2c5721;background-color:#e0e0e03d;font-size:13px}.ui.button.btnReloadData .i.icon,.ui.button.btnReloadData i.icons{padding-right:2px!important;color:#e0e0e0}.btnUploadFile,.ui.button.btnUploadFile{padding:0 15px;margin:0;height:49px;background-color:#fff;font-size:13px;margin-left:5px;min-width:100px;border:1px solid;border-color:#dededf}.ui.button.btnDeleteFile{padding:0;margin:0;width:20px;height:20px;color:#e70000;background:hsla(0,0%,100%,0);font-size:13px}.ui.button.btnDeleteFile .i.icon,.ui.button.btnDeleteFile i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnDownloadFile{padding:0;margin:0;width:20px;height:20px;color:#1b2c57;background:hsla(0,0%,100%,0);font-size:18px}.ui.button.btnDownloadFile .i.icon,.ui.button.btnDownloadFile i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.addNewItem{font-size:3rem;height:1vh;background:url(/assets/images/btn_add.png);background-repeat:no-repeat;background-size:contain;padding-left:1vh}.ui.button.btnEdit{padding:0;margin:0;width:30px;height:30px;color:#e0e0e0;background-color:#dde01a;font-size:13px;margin-left:5px}.ui.button.btnEdit .i.icon,.ui.button.btnEdit i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnDelete{padding:0;margin:0;width:30px;height:30px;color:#e0e0e0;background-color:#d83838;font-size:13px;margin-left:5px}.ui.button.btnDelete .i.icon,.ui.button.btnDelete i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnConfirm{padding:0;margin:0;width:30px;height:30px;color:#e0e0e0;background-color:#06be2e;font-size:13px;margin-left:5px}.ui.button.btnConfirm .i.icon,.ui.button.btnConfirm i.icons{padding-right:2px!important;color:#e0e0e0}.ui.button.btnActionModal{padding:0;margin:0;width:30px;height:30px;color:#000;background-color:unset;font-size:13px;margin-left:5px}.ui.button.btnActionModal .i.icon,.ui.button.btnActionModal i.icons{padding-right:2px!important;color:#e0e0e0}.iconBtnConfirm{padding:0;margin:0!important;width:30px!important;height:30px!important;color:#e0e0e0;background-color:#0b6ddd;font-size:13px!important;border-radius:3px;padding-top:7.5px}.btnIcon,.ui.circular.btnIcon{width:40px;height:40px;margin-top:20px;padding:0!important;padding-right:2px!important}.btnIcon .ui.circular.button>.icon,.ui.circular.btnIcon .ui.circular.button>.icon{padding-right:2px!important;margin-top:5px!important}.btnIcon i.icon:hover,.ui.circular.btnIcon i.icon:hover{background-color:inherit!important;color:inherit!important;border:inherit!important}.ui.circular.btnIcon>.icon{font-size:20px;padding-top:5px;padding-right:2px!important}.ui.button.btnDisplay{height:23vh;width:23vh;background-repeat:no-repeat;background-size:cover}.ui.button.btnDisplay.login{background:url(\"/assets/images/icon_card.png\");background-size:100%;background-repeat:no-repeat}.ui.button.btnDisplay.loginFail{background:url(\"/assets/images/icon_card_fail.png\");background-size:100%;background-repeat:no-repeat}.ui.button.btnDisplay.loginAdmin{background:url(\"/assets/images/button/btn_card_admin.png\");background-size:100%;background-repeat:no-repeat}.ui.button.btnDisplay.btnStart{background:url(\"/assets/images/button/btn_start.png\");background-size:100%}.ui.button.btnDisplay.btnStart.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnStart.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnResume{background:url(\"/assets/images/button/btn_resume.png\");background-size:100%}.ui.button.btnDisplay.btnResume.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnResume.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnLogout{background:url(\"/assets/images/button/btn_logout.png\");background-size:100%}.ui.button.btnDisplay.btnLogout.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnLogout.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnStop{background:url(\"/assets/images/button/btn_stop.png\");background-size:100%}.ui.button.btnDisplay.btnStop.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnStop.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnPause{background:url(\"/assets/images/button/btn_pause.png\");background-size:100%}.ui.button.btnDisplay.btnPause.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnPause.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnFinish{background:url(\"/assets/images/button/btn_finish.png\");background-size:100%}.ui.button.btnDisplay.btnFinish.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnFinish.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnCheckInOut{background:url(\"/assets/images/button/btn_checkInOut.png\");background-size:100%}.ui.button.btnDisplay.btnCheckInOut.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnCheckInOut.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnHelp{background:url(\"/assets/images/button/btn_help.png\");background-size:100%}.ui.button.btnDisplay.btnHelp.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnHelp.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnEnter{background:url(\"/assets/images/button/btn_confirm.png\");background-size:100%}.ui.button.btnDisplay.btnEnter.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnEnter.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnBackDisplay{background:url(\"/assets/images/button/btn_back.png\");background-size:100%}.ui.button.btnDisplay.btnBackDisplay.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnBackDisplay.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnArrowUp{background:url(\"/assets/images/button/btn_arrow_up.png\");background-size:100%}.ui.button.btnDisplay.btnArrowUp.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnArrowUp.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnArrowDown{background:url(\"/assets/images/button/btn_arrow_down.png\");background-size:100%}.ui.button.btnDisplay.btnArrowDown.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnArrowDown.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnSettings{background:url(\"/assets/images/button/btn_settings.png\");background-size:100%}.ui.button.btnDisplay.btnSettings.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnSettings.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnDeleteData{background:url(\"/assets/images/button/btn_delete.png\");background-size:100%}.ui.button.btnDisplay.btnDeleteData.medium{height:16vh;width:16vh}.ui.button.btnDisplay.btnDeleteData.small{height:7vh;width:7vh}.ui.button.btnDisplay.btnMenuSelect{width:77vw;margin-bottom:1.5vh;font-size:3.7em;height:12.5vh;background-color:#fff}.ui.button.btnDisplay.btnMenuSelect:focus{border-radius:unset!important;color:#353386!important;background-color:#ff0048}.btnAddText,.ui.button.btnAddText{padding:0 30px;margin:0;height:40px;color:#272727;background-color:#f2711c;font-size:13px;min-width:100px;margin-left:5px}.btnAddUpdate,.btnAddView,.ui.button.btnAddUpdate,.ui.button.btnAddView{padding:9px;height:41px;color:#272727;background-color:#f2711c;font-size:18px;min-width:75px;margin:auto}.ui.checkbox,.ui.dropdown,.ui.form,.ui.form .field>label,.ui.form textarea,.ui.input,.ui.input input,.ui.steps .step .title,.ui[class*=\"left icon\"].input>input,a,body,button,div,h1,h2,h3,h4,h5,h6,p,span{font-family:roboto}body{background-color:#f9f9f9}p{margin:0;color:#7c7c7c}.ui.checkbox,.ui.checkbox label,.ui.dropdown,.ui.form,.ui.form textarea,.ui.input,.ui.input input{color:#7c7c7c!important}.gridNogMargin,.gridNoPaddingMargin,.gridNoPaddingMargin>.column,.gridNoPaddingMargin>.row,.gridNoPaddingMargin>.row>.column{padding:0!important;margin:0!important}.gridColumnNoPaddingTB{padding-top:0!important;padding-bottom:0!important}.contentHeightMax{height:100%}.scrollListFormBox{height:140px;overflow-y:scroll;padding:1rem;background-color:#353386}.boxDatePicker{width:200px}.boxDatePicker.fluid{width:100%}.listSelectAll{padding-bottom:.42857143em;padding-top:.42857143em;background-color:#fff}.iWAAXb{padding:0 25px 0 10px!important}.ui.dimmer{z-index:2000!important;position:fixed!important}.iconMenuRowTable{cursor:pointer}.boxHeaderPage p{font-weight:700}.noselect{-webkit-touch-callout:none!important;-webkit-user-select:none!important;-khtml-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}@media only screen and (max-width:767px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:10px;padding-right:10px}.customContainer .boxHeader.desktop,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.desktop,.module.layoutMaster .boxHeader.desktop{display:none}.customContainer .boxBody .boxContent,.module.layoutMaster .boxBody .boxContent,.module.layoutMaster .boxBody .boxContent .contentBox .boxBody .boxContent{padding-top:50px}.customContainer .module.transfer .desktop,.module.layoutMaster .module.transfer .desktop{display:none}}@media only screen and (min-width:768px) and (max-width:991px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:30px;padding-right:30px}.customContainer .boxHeader.desktop,.customContainer .module.transfer .mobileSize,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.desktop,.module.layoutMaster .boxHeader.desktop,.module.layoutMaster .module.transfer .mobileSize{display:none}}@media only screen and (min-width:992px) and (max-width:1199px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:60px;padding-right:30px}.customContainer .boxHeader.mobile,.customContainer .module.transfer .mobileSize,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.mobile,.module.layoutMaster .boxHeader.mobile,.module.layoutMaster .module.transfer .mobileSize{display:none}}@media only screen and (min-width:1200px) and (max-width:1919px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:100px;padding-right:60px}.customContainer .boxHeader.mobile,.customContainer .module.transfer .mobileSize,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.mobile,.module.layoutMaster .boxHeader.mobile,.module.layoutMaster .module.transfer .mobileSize{display:none}}@media only screen and (min-width:1920px){.customContainer,.module.layoutMaster,.module.layoutMaster .boxBody .boxContent .contentBox{padding-left:150px;padding-right:60px}.customContainer .boxHeader.mobile,.customContainer .module.transfer .mobileSize,.module.layoutMaster .boxBody .boxContent .contentBox .boxHeader.mobile,.module.layoutMaster .boxHeader.mobile,.module.layoutMaster .module.transfer .mobileSize{display:none}}.scrollListFormBox{height:200px;overflow-y:auto;overflow-x:hidden;border:1px solid #e6e7e8;border-radius:.285714rem;background-color:#fff;padding:10px}.cursor-pointer{cursor:pointer}.div-flex{display:flex}p.white-space{white-space:normal}p.textDetailModal,p.white-space{color:rgba(0,0,0,.87);font-size:16px}b.textSubjectModal{font-size:16px;color:#2c75b7}.tooltip{position:relative;display:inline-block}.tooltip .tooltiptext{visibility:hidden;width:120px;background-color:#000;color:#fff;text-align:center;padding:5px 0;border-radius:6px;position:absolute;z-index:1}.tooltip:hover .tooltiptext{visibility:visible}.MuiTypography-body1{font-size:1.5rem!important}.MuiTypography-body2{font-size:1.25rem!important}.MuiTypography-caption{font-size:1.2rem!important}.MuiTypography-subtitle1{font-size:2rem!important}.MuiButton-root{font-size:1.25rem!important}.MuiPickersModal-dialogRoot{width:370px!important}.MuiPickersBasePicker-pickerView{min-width:370px!important;width:370px}.flagMenu.active{width:30px;opacity:1;cursor:pointer}.flagMenu{opacity:.5;width:30px;cursor:pointer}.paddingLeft5{padding-left:5px}.padding10{padding:10px}.padding15{padding:15px}.padding20{padding:20px}.marginLeft5{margin-left:5px}.marginLeft10{margin-left:10px}.margin10{margin:10px}.ui.steps{border:none}.kQuRQn{overflow-x:unset!important;overflow-y:unset!important}.iBMnVw{cursor:pointer}.eRFaRs{overflow-y:unset!important}.ui.steps .step,.ui.steps .step:first-child,.ui.steps .step:last-child{border-radius:5px;min-width:100px;height:50px;background-color:#e0e0e0;color:#7c7c7c}.ui.steps .step:after{display:none!important}.ui.steps .step.active,.ui.steps .step.active:hover{background-color:#353386!important}.ui.steps .step.active .title,.ui.steps .step.active .title:hover{color:#e0e0e0!important}.ui.steps a.step:hover{background-color:#e0e0e0!important}.ui.form .disabled.field,.ui.form .disabled.fields .field,.ui.form .field.disabled>label,.ui.form .field :disabled,.ui.form .fields.disabled>label{opacity:1}.ui.form .field>label{min-height:20px}.module.itemSettingBox .boxTextHeaderSetting p,.module.itemSettingBox .boxTextValueSetting p,.textOverflow{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ui.menu{background-color:#f9f9f9}.ui.form .field>.selection.dropdown{min-width:auto}.ui.selection.active.dropdown .menu{width:150px}.fontBodyImportant,.text,.ui.checkbox,.ui.dropdown,.ui.dropdown>.text,.ui.form,.ui.input{font-size:16px!important;width:100%}.ui.input.error>input{background-color:#fff6f6;border-color:#e0b4b4;color:#9f3a38;-webkit-box-shadow:none;box-shadow:none}.ui.form .field .ui.input input,.ui.form .fields .field .ui.input input{padding:5px!important;font-weight:200}.MuiTableSortLabel-root{font-size:16px;padding:5px 0!important;font-weight:800}.MuiTableRow-head,.MuiTableRow-hover,.MuiTableRow-root{padding:15px}.MuiTableCell-paddingNone{padding:inherit!important}.MuiTableCell-root,.MuiTablePagination-select{font-size:16px!important;font-weight:300!important}.footer{position:fixed;bottom:0;right:0;padding:20px 10px;text-align:right;background-color:#f9f9f9;width:100vw}.footer.center{text-align:center}.footer.mobile{padding:10px}.ui.form .field .ui.input,.ui.form .fields .field .ui.input,.ui.form .wide.field .ui.input{height:40px}.ui.steps .step .title{font-size:16px}.ui.disabled.input,.ui.input:not(.disabled) input[disabled]{opacity:.7}.ui.disabled.dropdown,.ui.disabled.dropdown .ui.dropdown>.text,.ui.disabled.input>input,.ui.disabled.input>input .ui.dropdown>.text,.ui.input:not(.disabled) input[disabled],.ui.input:not(.disabled) input[disabled] .ui.dropdown>.text{background-color:#dadada;color:#5a5a5a!important}.ui.form .inline.fields{margin:0}.ui.table thead{width:100%}.ui.sortable.table thead th{font-size:19px;text-align:center;font-weight:700;background-color:#e4e4e4}.ui.celled.table tr td,.ui.celled.table tr th{font-size:17px;overflow-wrap:anywhere}table tbody tr:nth-child(2n){background:#f7f5f5}.ui.sortable.table thead th.noSort:hover{background:#f7f7f7;color:inherit;cursor:inherit}.cursorPointer{cursor:pointer}.marginBottom10{margin-bottom:10px!important}.width100{width:100%!important}.homePage{width:100%;display:flex!important;justify-content:center;align-items:center!important;margin-top:35vh!important;text-align:center}.pageNotFound img.ui.image{display:inline-flex;width:250px}.pageNotFound h1{font-size:26px}.pageNotFound .char404{font-size:36px;color:#ff2d2d}@media{.page-break{display:none}}@media print{body,html{-webkit-print-color-adjust:exact}}@media print{.page-break{page-break-before:always}}.module.loadableController,.module.loadableRoute{height:100vh;display:flex;justify-content:center;align-items:center}.module.loadableController{position:fixed;overflow:auto}.module.switchLanguage{display:flex}.module.switchLanguage .language-item.select{background-color:#ccc}.module.errorBoundary .grid-header{padding-top:50px}.module.header{margin:0;box-shadow:0 4px 12px 0 rgba(0,0,0,.05)!important;background-color:#353386!important;position:absolute;width:100%;margin:0!important;top:0;z-index:2000}.module.header .logo-box{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.module.header .logo-box img{display:inline-block;max-width:100%;max-height:100%}.module.header .menu-item.logoUser{padding-top:0;padding-bottom:0}.module.header .menu-item.logo{padding:0;width:150px;height:50px}.module.header .menu-item.text p{color:#353386!important;font-weight:700}.module.header .menuBoxDesktop{width:100%}.module.header .menuBoxDesktop .menuRight{width:100%;height:100%;justify-content:flex-end}.module.header .menuBoxMobile{width:100%;display:flex}.module.header .menuMobile{padding:0!important}.module.header .menuMobile>i{display:none!important}.module.header .imageMenuMobile>i{margin:0!important}.module.header .itemMenuDropdown,.module.header .subMenuDropdown{width:180px}.module.header .userImage{width:40px;height:40px;border-radius:50%;overflow:hidden;cursor:pointer}.module.header .userImage img{width:100%;height:100%}.module.errorModal>.header{background-color:#353386}.module.errorModal>.actions,.module.errorModal>.header{border:none!important;padding:15px!important}.module.errorModal .boxHeaderContent{height:100px;display:flex;justify-content:center;align-items:center}.module.errorModal .boxHeaderContent .boxImageClose{width:16px;height:16px;display:inline-block;position:absolute;right:15px;top:15px;opacity:.3;cursor:pointer}.module.errorModal .boxHeaderContent .boxImageClose img{display:block!important;width:100%;height:100%}.module.errorModal .boxHeaderContent .boxImageClose:hover{opacity:unset}.module.errorModal .boxHeaderContent .boxImageLogo{width:80px;height:80px;display:inline-block}.module.errorModal .boxHeaderContent .boxImageLogo img{display:block!important;width:100%;height:100%}.module.errorModal .itemError{padding:10px 0!important}.module.errorModal .detailError{margin:0}.module.errorModal .detailError.header{font-weight:700}.module.errorModal .boxErrorParam{padding-left:15px}.module.actionModal .ui.button{font-size:16px;padding:10px;margin:0!important;background-color:#1b2c57;color:#ccc}.module.actionModal .danger p,.module.actionModal .warning p{color:#353386}.module.actionModal .danger .dialogHeader{padding-top:5px}.module.actionModal .danger .boxImageClose{margin-top:15px}.module.actionModal .headerBG{height:65px}.module.actionModal .headerBG.danger,.module.actionModal .headerBG.detail,.module.actionModal .headerBG.warning{background-color:#e6e7e8}.module.actionModal>.actions,.module.actionModal>.header{border:none!important;padding:15px!important}.module.actionModal .boxHeaderContent{display:flex;justify-content:center;align-items:center;flex-direction:column}.module.actionModal .boxHeaderContent .boxImageClose{width:16px;height:16px;display:inline-block;position:absolute;right:15px;top:-5px;opacity:.3;cursor:pointer}.module.actionModal .boxHeaderContent .boxImageClose img{display:block!important;width:100%;height:100%}.module.actionModal .boxHeaderContent .boxImageClose:hover{opacity:unset}.module.actionModal .boxHeaderContent .boxImageLogo{width:80px;height:80px;display:inline-block}.module.actionModal .boxHeaderContent .boxImageLogo img{display:block!important;width:100%;height:100%}.module.actionModal .boxHeaderContent .boxTextHeader p{font-size:16px;font-weight:700}.module.actionModal .boxTextDetail{min-height:9vh;max-height:60vh;overflow-y:scroll;overflow-x:hidden}.module.actionModal .boxAction{margin-top:1.5rem;position:absolute;z-index:999;text-align:center;width:100%;margin-bottom:5px}.module.inputForm{width:100%}.module.inputForm .formField{margin:0!important}.module.inputForm .formField.pickerType{position:relative}.module.inputForm .disabledInput{opacity:.45}.module.inputForm .boxViewValue{background-color:#fff;padding:1rem}.module.inputForm .boxViewValue p{margin:0!important}.module.inputForm .boxViewValue.mini{width:20%}.module.inputForm .boxViewValue.small{width:50%}.module.inputForm .labelInput p{margin:0!important}.module.inputForm .labelInput .required,.module.inputForm .labelInput .subject{font-weight:700;display:inline-block}.module.inputForm .labelInput .required{color:red}.module.inputForm .boxDatePicker>.MuiFormControl-root{display:none!important}.module.inputForm .textValid{color:red}.module.inputForm .hidePicker{display:none}.module.inputForm .inputFile,.module.inputForm .inputFile input,.module.inputForm .inputPicker,.module.inputForm .inputPicker input{opacity:unset!important}.module.inputForm .btnPicker,.module.inputForm .btnUploadFile{position:absolute;top:50%;right:0;transform:translateY(-50%)}.module.inputForm .btnPicker button,.module.inputForm .btnUploadFile button{transform:translateX(-30%)}.module.inputForm .boxColumSubjectTop{padding-top:1rem!important}.module.inputForm .headerBoxHeaderTap{font-weight:700}.module.inputForm .editorInputHtml{height:275px!important;border:1px solid #f1f1f1!important;padding:5px!important;border-radius:2px!important;background-color:#fff}.module.inputForm .boxInputUploadFile{display:flex}.module.inputForm .boxInputUploadFile .inputBox{flex:1}.module.inputForm .boxInputUploadFile .actionBox{flex:0 0 auto}.module.inputForm .boxInputUploadFile .actionBox button{height:100%;margin-right:0;margin-left:.5rem}.module.popupUser .userContent{display:flex;widows:200px}.module.popupUser .userContent .contentImage{flex:0 0 auto;width:70px;height:70px;border-radius:50%;overflow:hidden}.module.popupUser .userContent .contentImage img{width:100%;height:100%}.module.popupUser .userContent .contentDetail{padding-left:1rem;flex:1}.module.popupUser .userContent .contentDetail .detailUser .name{font-weight:700}.module.popupUser .userAction{border-top:1px solid #ccc;display:flex;justify-content:flex-end;margin-top:1rem;padding-top:1rem}.module.popupUser .userAction button{padding-top:.5rem;padding-bottom:.5rem}.holiday{background:#f1f1f1}.speciaoHliday{background:#e85e6c}.fc-time-area .fc-rows td>div{height:100px!important}.fc-highlightSelect{background-color:#4183c4;height:99px!important;margin-top:1px!important;margin-left:1px!important}.fc-eventCustom{background-color:red;border:1px solid #fff}.fc-holiday{background-color:#ccc}.module.customTable{padding-bottom:0;height:100%;width:100%;overflow:hidden;overflow-x:auto}.module.customTable .boxNoData{padding:3rem 0}.module.customTable .boxNoData p{font-weight:700}.module.customTable .ui.icon.button{padding:0;width:30px;height:30px;color:#e0e0e0;background-color:#1b2c57;font-size:13px}.module.customTable .ui.icon.button .i.icon,.module.customTable .ui.icon.button i.icons{padding-right:2px!important;color:#e0e0e0}.module.customTable .ui.icon.button.btnUndo{background-color:#279b54;margin-right:5px;color:#fff}.module.customTable .ui.icon.button.btnDelete{background-color:#d1052c;margin-right:5px;color:#fff}.layoutHelper{text-align:left}.layoutHelper .helperKey{position:fixed;left:0;margin-left:10px;margin-top:-5px;display:inline-flex}.layoutHelper .helperKey.modal{position:unset}.layoutHelper .helperKey .keyGuide{margin-top:10px;font-size:16px;color:#000!important}.layoutHelper .helperKey .box-button{height:45px;width:60px;border:1px solid #d4d4d4;text-align:center;padding:2px;border-radius:2px;margin:0 5px}.layoutHelper .helperKey .box-button p{color:#000!important}.layoutHelper .helperKey .box-button p.iconKey{font-size:22px}.layoutHelper .helperKey .box-button p.iconKey.plus{font-size:30px}.layoutHelper .helperKey .box-button p.textKey{font-size:10px;margin-top:-5px}.actionsLeftHelperKey{padding-top:15px;text-align:left!important}.module.layoutWithSidebar .sidebarBox{position:fixed;display:flex;flex-direction:column;top:0;bottom:0;left:0;width:250px;background-color:#353386;overflow-x:hidden;flex:1}.module.layoutWithSidebar .sidebarBox .headerBox{flex:0 0 auto;padding:10px;display:flex;justify-content:center;align-items:center;flex-direction:column}.module.layoutWithSidebar .sidebarBox .headerBox .imageBox{max-width:230px;height:60px}.module.layoutWithSidebar .sidebarBox .headerBox .imageBox img{height:100%;display:block}.module.layoutWithSidebar .sidebarBox .headerBox .text p{color:#353386;font-weight:700}.module.layoutWithSidebar .sidebarBox .actionBox{border-top:1px solid #e6e7e8}.module.layoutWithSidebar .sidebarBox .actionBox .userBox p{color:#353386;font-weight:700}.module.layoutWithSidebar .sidebarBox .actionBox .btnBox{margin-top:10px}.module.layoutWithSidebar .sidebarBox .actionBox .btnBox button{padding-top:5px;padding-bottom:5px;width:100%}.module.layoutWithSidebar .sidebarBox .headerBox{border-bottom:1px solid #353386}.module.layoutWithSidebar .sidebarBox .actionBox,.module.layoutWithSidebar .sidebarBox .headerBox{flex:0 0 auto;padding:10px}.module.layoutWithSidebar .sidebarBox .menuBox{flex:1;overflow-y:auto}.module.layoutWithSidebar .bodyBox{margin-left:250px;min-width:550px;padding:2rem}.module.layoutWithSidebar .menuSidebar{width:100%;margin:0!important;min-height:unset;border:none;border-radius:unset}.module.layoutWithSidebar .menuSidebar .item{margin:0!important;color:#353386;font-weight:700;background-color:#353386;border-radius:unset!important}.module.layoutWithSidebar .menuSidebar .active.item,.module.layoutWithSidebar .menuSidebar .item:hover{border-radius:unset!important;color:#353386!important;background-color:#353386}.module.layoutWithSidebar .menuSidebar .active.item{margin:0!important;font-weight:700;cursor:unset!important}.module.layoutWithSidebar .menuSidebar .active.item:hover{border-radius:unset!important;color:#353386!important;background-color:#353386}.module.layoutWithSidebar #sidebarScroll::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3);background-color:#353386}.module.layoutWithSidebar #sidebarScroll::-webkit-scrollbar{width:10px;background-color:#353386}.module.layoutWithSidebar #sidebarScroll::-webkit-scrollbar-thumb{border-radius:0;background-color:#353386;border:2px solid #353386}.layoutBlankMaster{background:#f0b9a4;padding:18px;height:100vh;height:calc(var(--vh, 1vh) * 100);display:flex;flex-direction:column;align-items:center;justify-content:space-between}.module.layoutBlank{overflow-x:hidden;overflow-y:auto;width:98%;height:90vh;background:#f8dbd0;padding:10px 40px;border-radius:4px;margin-top:8px}.module.layoutBlank .headerTitle{font-size:16px;font-weight:700;text-align:center}@media only screen and (min-width:0px) and (max-width:767px){.layoutBlank{padding:10px!important}}.module.layoutMaster,.module.layoutMaster .boxBody{background-color:#f9f9f9;height:100vh}.module.layoutMaster .boxBody{display:flex;flex:1;flex-direction:column}.module.layoutMaster .boxBody .boxHeader.expand{width:250px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage{width:100%;padding:5px;display:inline-flex;height:50px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .imageItem,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .imageItem{width:30%}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .imageItem img.ui.image,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .imageItem img.ui.image{margin-top:10px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem{width:70%}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .fullName,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .fullName{margin-top:-5px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .fullName p,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .fullName p{padding-top:5px;font-size:14px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .logout,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .logout{margin-top:-10px}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .headerText,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .headerText{margin-top:10px;font-weight:400;text-align:left}.module.layoutMaster .boxBody .boxHeader.expand .item .itemIcon .contentItem .headerText p,.module.layoutMaster .boxBody .boxHeader.expand .item .userImage .contentItem .headerText p{font-size:13px}.module.layoutMaster .boxBody .boxHeader.expand .item.bottom{left:140px}.module.layoutMaster .boxBody .boxHeader.expand .item.bottom p{padding-left:15px}.module.layoutMaster .boxBody .boxHeader.expand .item.bottom .language{padding-left:8px}.module.layoutMaster .boxBody .boxHeader.expand .item.logo img.ui.image{width:180px;height:40px}.module.layoutMaster .boxBody .boxHeader{position:fixed;left:0;z-index:200;height:100vh;width:85px;background-color:#f9f9f9;border-right:1px solid #ccc;box-shadow:3px 0 7px #ccc;border-top-right-radius:10px}.module.layoutMaster .boxBody .boxHeader .item.logo{height:65px;padding:10px 5px;display:inline-flex}.module.layoutMaster .boxBody .boxHeader .item.logo i.icon{width:auto!important;margin-right:10px;margin-top:10px;padding-top:0;font-size:25px}.module.layoutMaster .boxBody .boxHeader .item.logo img.ui.image{width:40px;height:40px}.module.layoutMaster .boxBody .boxHeader .item{height:50px;overflow:hidden;cursor:pointer;width:100%}.module.layoutMaster .boxBody .boxHeader .item .itemIcon,.module.layoutMaster .boxBody .boxHeader .item .userImage{width:100%;text-align:center;height:40px}.module.layoutMaster .boxBody .boxHeader .item .itemIcon img.ui.image,.module.layoutMaster .boxBody .boxHeader .item .userImage img.ui.image{left:45%;transform:translate(-45%);width:30px;height:30px;border-radius:5px;margin-top:5px}.module.layoutMaster .boxBody .boxHeader .item .itemIcon .fullName,.module.layoutMaster .boxBody .boxHeader .item .itemIcon .logout,.module.layoutMaster .boxBody .boxHeader .item .userImage .fullName,.module.layoutMaster .boxBody .boxHeader .item .userImage .logout{text-align:left}.module.layoutMaster .boxBody .boxHeader .item .itemIcon .fullName,.module.layoutMaster .boxBody .boxHeader .item .userImage .fullName{font-weight:700;padding-top:5px}.module.layoutMaster .boxBody .boxHeader .item .itemIcon .fullName p,.module.layoutMaster .boxBody .boxHeader .item .userImage .fullName p{text-overflow:ellipsis;white-space:nowrap;height:30px;overflow:hidden;width:20ch}.module.layoutMaster .boxBody .boxHeader .item i.icon{padding-top:5px;text-align:center;font-size:30px;margin:0}.module.layoutMaster .boxBody .boxHeader .item .logout{cursor:pointer}.module.layoutMaster .boxBody .boxHeader .item .logout p{font-size:12px}.module.layoutMaster .boxBody .boxHeader .item.active{background-color:#e8e8e8}.module.layoutMaster .boxBody .boxHeader .item.line{border-top:1px solid #ccc;width:100%;height:1px;padding:0}.module.layoutMaster .boxBody .boxHeader .item.bottom{position:fixed;left:0;bottom:0;display:inline-table;padding:0;padding-bottom:10px;width:250px}.module.layoutMaster .boxBody .boxHeader .item.bottom p{font-size:12px;padding-left:8px}.module.layoutMaster .boxBody .boxHeader .item.bottom .language img.ui.image{display:inline;width:25px}.module.layoutMaster .boxBody .boxContent{padding-bottom:50px;height:100vh}.module.layoutMaster .boxBody .boxContent .contentBox{background-color:#f9f9f9;padding-top:2rem;width:100%;padding-bottom:100px}.module.layoutMaster .boxBody .boxHeader.mobile{width:100vw;z-index:200;position:fixed;left:0;height:45px;background-color:#f9f9f9}.module.layoutMaster .boxBody .boxHeader.mobile .item.logo{height:65px;padding:10px 5px;display:inline-flex}.module.layoutMaster .boxBody .boxHeader.mobile .item.logo img.ui.image{width:30px;height:30px}.module.layoutMaster .boxBody .boxHeader.mobile .item.logo i.icon{width:auto!important;margin-right:10px;margin-top:3px;padding-top:0;font-size:25px}.module.layoutMaster .boxBody .boxHeader.mobile.expand{height:100%;width:80vw}.module.layoutMaster .boxBody .boxHeader.mobile.expand .item.bottom{height:100vh;top:80%;left:50vw}.module.layoutMaster .logoImageHeader img{width:8rem;margin:0;display:inline-flex}.module.menuData .boxMenu{display:flex;flex-direction:row}.module.menuData .boxMenu .itemMenu{border:1px solid #353386;text-align:center;min-width:140px;padding:5px 0;cursor:pointer;background-color:#353386;transition:color .5s,background-color .5s}.module.menuData .boxMenu .itemMenu p{font-weight:700;color:#353386!important}.module.menuData .boxMenu .itemMenu.active{background-color:#353386}.module.menuData .boxMenu .itemMenu.active p{color:#353386!important}.module.menuData .boxMenu .itemMenu:hover{background-color:#353386}.module.menuData .boxMenu .itemMenu:hover p{color:#353386!important}.module.menuData .boxMenu .itemMenu:first-child{border-top-left-radius:5px;border-bottom-left-radius:5px}.module.menuData .boxMenu .itemMenu:last-child{border-top-right-radius:5px;border-bottom-right-radius:5px}.overflowWrap{overflow-wrap:anywhere;align-self:center}.menuRightData{float:right}.txtFullName{font-size:18px}.module.layoutDisplay{width:100%;background:linear-gradient(90deg,#fffdfc 0,#fffdfc 50%,#f4caba 0,#f4caba);height:100vh;height:calc(var(--vh, 1vh) * 100);overflow-x:hidden;overflow-y:hidden;display:flex;justify-content:center;align-items:center;flex:1;padding:15px}.module.layoutDisplay .headerSection{position:absolute;top:0;height:5vh;width:100vw}.module.layoutDisplay .headerSection .headerText{padding-right:3vw;padding-top:1.2vh;text-align:right;font-size:1.8em;color:#fff}.module.layoutDisplay .contentSection{width:100%}.module.layoutDisplay.backgroundBlack{background-color:#111a26}.module.layoutPD{background-color:#fff;height:100vh;height:calc(var(--vh, 1vh) * 100);display:flex;justify-content:center;flex:1;padding:24px 40px}.module.layoutPD .headerSection{position:absolute;top:0;height:5vh;width:100vw}.module.layoutPD .headerSection .headerText{padding-right:3vw;padding-top:1.2vh;text-align:right;font-size:1.8em}.module.layoutPD .contentSection{width:100%}.module.layoutDisplay.backgroundBlack{background-color:#fff}.module.login{text-align:center;margin-top:-50px}.module.login .logoImage img{width:45rem;margin:0;display:inline-flex}.module.login .loginButton{padding-top:30px}.module.loginForm .image-box{display:flex;justify-content:center;align-items:center}.module.loginForm .image-box .image{max-width:100%}.module.loginForm .image-box .image img{width:100%;display:block}.module.loginForm .text-box{text-align:left}.module.loginForm .text-box p{margin:0;font-weight:700}.module.itemSettingBox{width:100%}.module.itemSettingBox .boxTextValueSetting{height:70px;display:flex;justify-content:center;align-items:center}.module.itemSettingBox .boxTextValueSetting p{font-weight:700}.module.itemSettingBox .boxTextValueSetting img{width:100%;max-height:100%;display:block}.module.itemSettingBox .boxTextValueSetting .btnAction{position:absolute;right:0;top:0}.module.itemSettingBox .boxTextHeaderSetting{display:flex;justify-content:center;align-items:center}.module.itemSettingBox .boxTextHeaderSetting p{font-weight:700}.module.itemMailContentBox{width:100%}.module.itemMailContentBox .boxEnabled{display:flex}.module.itemMailContentBox .boxEnabled p{font-weight:700;margin-right:1rem}.module.itemMailContentBox .boxMailContent .boxContent .subject,.module.itemMailContentBox .boxMailContent .boxSubject .subject{font-weight:700;margin:0}.module.itemMailContentBox .boxMailContent .boxContent .detail,.module.itemMailContentBox .boxMailContent .boxSubject .detail{margin-left:1rem}.reportForm .stepHeader h1{color:#353386}.reportForm .contentReportInfomation{display:inline-flex;height:220px;overflow-y:scroll}.reportForm .accordionItem{display:inline-flex}.reportForm .accordionItem h1{margin:0;color:#353386}.reportForm .accordionItem i.icon{margin:7px 0 0!important}.reportForm .subItem2{padding:15px 40px;border:2px solid rgba(34,36,38,.15);border-radius:5px;margin:0 10px;margin-bottom:20px}.reportForm .subItem2 :last-child{margin-bottom:0}.reportForm .subItemError{background-color:#fba7a773;color:#4e4e4e}.reportForm .noMargin{margin:0!important}.reportForm .dataLabelItem{height:20px;display:inline-flex;position:absolute;padding-left:1rem}.reportForm .viewSummaryItem{padding:10px 30px}.reportForm .viewSummaryItem .generateCode{padding:10px;border:1px dotted #b8b8b8;border-radius:5px;background-color:#d5eafd69}.reportForm .viewSummaryItem .generateCode h2{padding:10px 0}.reportForm .error{color:red}.reportForm .viewSummaryHeader{display:contents;font-size:20px}.reportForm .viewSummarySubHeader{font-size:17px}.reportForm .checkBoxAssambly,.reportForm .radioSpecial{font-size:14px!important;padding-bottom:14px}.reportForm .btnRightConfirm{float:right;vertical-align:middle}.reportForm .tubeItem{padding:15px 20px;border:1px dotted #ccc;border-radius:10px;margin-bottom:5px}.reportForm .finItem,.reportForm .plateItem{padding:10px 25px!important;border:1px dotted #ccc;border-radius:10px;background-color:#f3f3f3;margin-bottom:5px}.reportForm .finItem.validateError,.reportForm .plateItem.validateError{background-color:#fde5e5}.reportForm .accordionError,.reportForm .ui.styled.accordion .title.accordionError{background-color:#ffc2c2}.reportForm .accordionSuccess,.reportForm .ui.styled.accordion .title.accordionSuccess{background-color:#d0ffc2}.actionLog{margin-top:50px}.actionLog .viewCommentHeader{font-size:small}.module.drawing{padding:20px 0}.module.drawing .header{width:80vw;position:fixed;z-index:100}.module.drawing .header .addDrawing{width:45px;height:45px;background-color:#f9f9f9;border:1px solid #ccc;margin:0;padding:0;margin-top:1rem}.module.drawing .header .addDrawing .icon{color:#ccc;font-size:28px;width:100%;height:100%;margin-top:10px!important}.module.drawing .header .tableDrawingHeader{display:inline-flex;padding:5px;width:100%;border-bottom:1px solid #ccc;padding-top:10px}.module.drawing .header .tableDrawingHeader .th{text-align:center;padding:10px;font-size:14px;font-weight:600}.module.drawing .header .tableDrawingHeader .drawingNo{width:20%}.module.drawing .header .tableDrawingHeader .customerCode,.module.drawing .header .tableDrawingHeader .status{width:15%}.module.drawing .header .tableDrawingHeader .drawingRev{width:5%}.module.drawing .header .tableDrawingHeader .action,.module.drawing .header .tableDrawingHeader .coilSize,.module.drawing .header .tableDrawingHeader .customerName,.module.drawing .header .tableDrawingHeader .pipeType{width:20%}.module.drawing .drawingContent{padding-top:13rem}.module.drawing .drawingContent .tableDrawingContent{width:81vw;height:70vh;overflow:hidden;overflow-y:scroll;padding:10px 0}.module.drawing .drawingContent .tableDrawingContent .tr{display:inline-flex;width:80vw;color:#757575;border-bottom:1px solid #ccc}.module.drawing .drawingContent .tableDrawingContent .tr:hover{background-color:#e6e6e6;color:#000}.module.drawing .drawingContent .tableDrawingContent .tr:hover .action .btnView{margin-right:5px;background-color:#1e48f9;color:#fff}.module.drawing .drawingContent .tableDrawingContent .tr:hover .action .btnAdd{background-color:#f4d522;margin-right:5px;color:#fff}.module.drawing .drawingContent .tableDrawingContent .tr:hover .action .btnDelete{margin:0;background-color:#d1052c;color:#fff}.module.drawing .drawingContent .tableDrawingContent .tr:hover .action .btnAdd:disabled,.module.drawing .drawingContent .tableDrawingContent .tr:hover .action .btnDelete:disabled,.module.drawing .drawingContent .tableDrawingContent .tr:hover .action .btnView:disabled{opacity:.4!important}.module.drawing .drawingContent .tableDrawingContent .tableItem{padding:10px}.module.drawing .drawingContent .tableDrawingContent .tr:last-child{border:none}.module.drawing .drawingContent .tableDrawingContent .drawingRev,.module.drawing .drawingContent .tableDrawingContent .status{text-align:center}.module.drawing .drawingContent .tableDrawingContent .drawingNo{width:20%}.module.drawing .drawingContent .tableDrawingContent .customerCode,.module.drawing .drawingContent .tableDrawingContent .status{width:15%}.module.drawing .drawingContent .tableDrawingContent .drawingRev{width:5%}.module.drawing .drawingContent .tableDrawingContent .action,.module.drawing .drawingContent .tableDrawingContent .coilSize,.module.drawing .drawingContent .tableDrawingContent .customerName,.module.drawing .drawingContent .tableDrawingContent .pipeType{width:20%}.module.drawing .drawingContent .tableDrawingContent .coilSize,.module.drawing .drawingContent .tableDrawingContent .customerCode,.module.drawing .drawingContent .tableDrawingContent .customerName,.module.drawing .drawingContent .tableDrawingContent .drawingNo,.module.drawing .drawingContent .tableDrawingContent .drawingRev,.module.drawing .drawingContent .tableDrawingContent .pipeType,.module.drawing .drawingContent .tableDrawingContent .status{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;margin-top:10px}.module.drawing .drawingContent .tableDrawingContent .action .btnAdd,.module.drawing .drawingContent .tableDrawingContent .action .btnAdd:disabled,.module.drawing .drawingContent .tableDrawingContent .action .btnDelete,.module.drawing .drawingContent .tableDrawingContent .action .btnDelete:disabled,.module.drawing .drawingContent .tableDrawingContent .action .btnView,.module.drawing .drawingContent .tableDrawingContent .action .btnView:disabled{margin-right:5px;background-color:#cecece;color:#fffefe;opacity:1!important}.module.drawing .drawingContent .tableDrawingContent .action .btnDelete{margin:0}.module.drawing .drawingContent .drawingShowAllContent{text-align:center;width:80%;z-index:200;padding:0;display:inline;position:absolute}.module.drawing .drawingContent .drawingShowAllContent .ui.button{font-size:16px;background-color:inherit;color:#1b2c57}.module.drawing .drawingContent .drawingShowAllContent .ui.button .icon{margin-left:10px}.module.home .topUserSubject{font-size:15px;font-weight:500;color:#4183c4}.module.home .topUserContent{font-size:13px}.module.home .topUserTitle{color:#4183c4;font-size:20px;font-weight:900}.module.home .card{padding:10px;margin:10px}.module.home .description{margin-top:15px!important}.module.home input,.module.home input[type=text]{border:1px solid #ccc;padding:10px;border-radius:5px;font-size:14px;color:#5d5d5d}.module.home .react-datepicker,.module.home .react-datepicker-time__header,.module.home .react-datepicker-year-header,.module.home .react-datepicker__current-month{font-size:1.4rem}.module.home p{font-size:16px;color:#5d5d5d}.module.home .controlButton{padding-top:30px}.module.home .title{font-size:20px;font-weight:900}.module.info{padding:3rem}.module.info .subject{font-size:16px;text-decoration:underline}.module.info .content{line-height:26px;padding:20px 0}.module.info .content ol.ui.list li{padding-bottom:10px;font-size:15px}.module.info .marginBottom20{margin-bottom:20px}.customMasterHome .ui.card{margin:10px}.customMasterHome .ui.card .header{text-overflow:ellipsis;overflow:hidden;height:1.2em;white-space:nowrap}.module.masterData .customMasterFormBorder{padding:40px 0}.module.masterData .ui.button{padding:10px;font-size:1.4rem;line-height:1.4rem}.module.masterData .addItem{margin-top:20px}.masterData{padding:20px 0}.masterData .tableMasterDataHeader{display:inline-flex;padding:5px;width:100%;border-bottom:1px solid #ccc;padding-top:10px}.sellForm .react-datepicker{font-size:1.1em}.sellForm .react-datepicker__header{padding-top:.8em}.sellForm .react-datepicker__month{margin:.4em 1em}.sellForm .react-datepicker__day,.sellForm .react-datepicker__day-name{width:1.9em;line-height:1.9em;margin:.166em}.sellForm .react-datepicker__current-month{font-size:1.1em}.sellForm .react-datepicker__navigation{top:1em;line-height:1.7em;border:.45em solid transparent}.sellForm .react-datepicker__navigation--previous{border-right-color:#ccc;left:1em}.sellForm .react-datepicker__navigation--next{border-left-color:#ccc;right:1em}.tableDownload{display:inline-flex;padding:5px;width:100%;border-bottom:1px solid #ccc;padding-top:10px}.tableDownload .th{padding:10px;font-size:12px;font-weight:600}.tableDownload .fileName{overflow-wrap:break-word;align-self:center;width:40%}.tableDownload .action,.tableDownload .createDate,.tableDownload .fileSize,.tableDownload .fileType{align-self:center;text-align:center;width:30%}.fileDownload{height:200px;overflow-y:auto}.ui.button.loading.clearBG{background-color:hsla(0,0%,100%,0)!important}.module.sellOrder{padding:20px 0}.module.sellOrder .header{width:80vw;position:fixed;z-index:100}.module.sellOrder .header .addSellOrder{width:45px;height:45px;background-color:#f9f9f9;border:1px solid #ccc;margin:0;padding:0;margin-top:1rem}.module.sellOrder .header .addSellOrder .icon{color:#ccc;font-size:28px;width:100%;height:100%;margin-top:10px!important}.module.sellOrder .header .tableSellOrderHeader{display:inline-flex;padding:5px;width:100%;border-bottom:1px solid #ccc;padding-top:10px}.module.sellOrder .header .tableSellOrderHeader .th{text-align:center;padding:10px;font-size:14px;font-weight:600}.module.sellOrder .header .tableSellOrderHeader .customerCode,.module.sellOrder .header .tableSellOrderHeader .isWaitingCustomerApprove,.module.sellOrder .header .tableSellOrderHeader .status{width:15%}.module.sellOrder .header .tableSellOrderHeader .accountNum,.module.sellOrder .header .tableSellOrderHeader .custGroup,.module.sellOrder .header .tableSellOrderHeader .drawingNo{width:10%}.module.sellOrder .header .tableSellOrderHeader .drawingRev,.module.sellOrder .header .tableSellOrderHeader .isNormalPriority,.module.sellOrder .header .tableSellOrderHeader .requestType{width:5%}.module.sellOrder .header .tableSellOrderHeader .action,.module.sellOrder .header .tableSellOrderHeader .customerName,.module.sellOrder .header .tableSellOrderHeader .pipeType{width:15%}.module.sellOrder .sellOrderContent{padding-top:13rem}.module.sellOrder .sellOrderContent .tableSellOrderContent{width:81vw;height:70vh;overflow:hidden;overflow-y:scroll;padding:10px 0}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr{display:inline-flex;width:80vw;color:#757575;border-bottom:1px solid #ccc}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover{background-color:#e6e6e6;color:#000}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover .action .btnView{margin-right:5px;background-color:#1e48f9;color:#fff}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover .action .btnAdd{background-color:#f4d522;margin-right:5px;color:#fff}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover .action .btnDelete{margin:0;background-color:#d1052c;color:#fff}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover .action .btnAdd:disabled,.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover .action .btnDelete:disabled,.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:hover .action .btnView:disabled{opacity:.4!important}.module.sellOrder .sellOrderContent .tableSellOrderContent .tableItem{padding:10px}.module.sellOrder .sellOrderContent .tableSellOrderContent .tr:last-child{border:none}.module.sellOrder .sellOrderContent .tableSellOrderContent .customerCode,.module.sellOrder .sellOrderContent .tableSellOrderContent .isWaitingCustomerApprove,.module.sellOrder .sellOrderContent .tableSellOrderContent .status{width:15%}.module.sellOrder .sellOrderContent .tableSellOrderContent .accountNum,.module.sellOrder .sellOrderContent .tableSellOrderContent .custGroup,.module.sellOrder .sellOrderContent .tableSellOrderContent .drawingNo{width:10%}.module.sellOrder .sellOrderContent .tableSellOrderContent .drawingRev,.module.sellOrder .sellOrderContent .tableSellOrderContent .isNormalPriority,.module.sellOrder .sellOrderContent .tableSellOrderContent .requestType{width:5%;text-align:center}.module.sellOrder .sellOrderContent .tableSellOrderContent .action,.module.sellOrder .sellOrderContent .tableSellOrderContent .customerName,.module.sellOrder .sellOrderContent .tableSellOrderContent .pipeType{width:15%}.module.sellOrder .sellOrderContent .tableSellOrderContent .status{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;margin-top:10px;text-align:center;font-size:medium}.module.sellOrder .sellOrderContent .tableSellOrderContent .REJECT,.module.sellOrder .sellOrderContent .tableSellOrderContent .SUBMIT{color:red}.module.sellOrder .sellOrderContent .tableSellOrderContent .PRE-APPROVE{color:#ecc900}.module.sellOrder .sellOrderContent .tableSellOrderContent .WAIT-CUSTOMER-APPROVE{color:#52b1ff}.module.sellOrder .sellOrderContent .tableSellOrderContent .COMPLETE{color:#87ff6a}.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnAdd,.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnAdd:disabled,.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnDelete,.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnDelete:disabled,.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnView,.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnView:disabled{margin-right:5px;background-color:#cecece;color:#fffefe;opacity:1!important}.module.sellOrder .sellOrderContent .tableSellOrderContent .action .btnDelete{margin:0}.module.sellOrder .sellOrderContent .sellOrderShowAllContent{text-align:center;width:80%;z-index:200;padding:0;display:inline;position:absolute}.module.sellOrder .sellOrderContent .sellOrderShowAllContent .ui.button{font-size:16px;background-color:inherit;color:#1b2c57}.module.sellOrder .sellOrderContent .sellOrderShowAllContent .ui.button .icon{margin-left:10px}.module.inputForm .editorInputHtml.drawingOrder{height:100px!important;border:1px solid #a8a8a8!important}.tableItem.status{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;margin-top:10px;text-align:center;font-size:medium}.tableItem.status .REJECT,.tableItem.status .SUBMIT{color:red}.tableItem.status .PRE-APPROVE{color:#ecc900}.tableItem.status .WAIT-CUSTOMER-APPROVE{color:#52b1ff}.tableItem.status .COMPLETE{color:#87ff6a}.tableItem.action .btnView{margin-right:5px;background-color:#1e48f9;color:#fff}.tableItem.action .btnView:hover{background-color:#1e4af963;margin-right:5px;color:#fff}.tableItem.action .btnAdd{background-color:#f4d522;margin-right:5px;color:#fff}.tableItem.action .btnAdd:hover{background-color:#f4d52257;margin-right:5px;color:#fff}.tableItem.action .btnDelete{margin:0;background-color:#d1052c;color:#fff}.tableItem.action .btnAdd:disabled,.tableItem.action .btnDelete:disabled,.tableItem.action .btnView:disabled{opacity:.4!important}.module.user .ui.button{font-size:1.2rem;line-height:16px}.module.transfer .desktop .header{background-color:#fff;border-radius:10px;padding:10px 15px}.module.transfer .desktop .header .titleText{font-size:2em;font-weight:bolder}.module.transfer .desktop .header .minWidth1{min-width:1em!important;font-size:1em!important}.module.transfer .desktop .header .minWidth1 .text{font-size:1.2em!important}.module.transfer .desktop .header .fieldTitle{font-size:1em}.module.transfer .mobileSize .header{background-color:#fff;border-radius:10px;padding:5px}.module.transfer .mobileSize .header .titleText{font-size:1.5dem;font-weight:bolder}.module.transfer .mobileSize .header .detailText{font-size:1.2em;font-weight:800}.module.transfer .mobileSize .header .minWidth1{min-width:1em!important;font-size:1em!important}.module.transfer .mobileSize .header .minWidth1 .text{font-size:1em!important}.module.transfer .mobileSize .header .fieldTitle{font-size:1em}.module.transfer .mobileSize .transferTable .dataRow{background-color:#fff;border-radius:10px;padding:5px 18px 0}.module.transfer .mobileSize .transferTable .dataRow .fieldName{font-size:.8em;word-break:break-word}.module.transfer .mobileSize .transferTable .dataRow .fieldValue{font-size:1em;font-weight:bolder;word-break:break-word}.module.transfer .modal .titleModal{margin-top:3vh;font-size:3em;line-height:5vh}.module.transfer .modal .btnAddText.transfer{font-size:2em}.itemRow{border:1.5px solid #e2e2e2;border-radius:10px;margin-top:10px;margin-bottom:10px;padding:5px 10px}.itemRow .itemTitle{font-size:1.3em}.itemRow .itemDetail{font-size:1.5em;word-break:break-word}.itemRow .modalQtyValue{width:15vh}.itemRow .btnAddText.transfer{background-color:#0f1a28;min-width:100px;height:50px;width:100%}.itemRow.number{margin-top:5vh;border:1.5px #e2e2e2;border-bottom-style:solid}.ui.button.btnScan{height:8vh;background:url(\"/assets/images/btn_scan.png\");background-size:80%;background-repeat:no-repeat}.ui.button.btnScan:disabled{background:url(\"/assets/images/btn_scan.png\")!important}.ui.button.btnAddManage{height:8vh;background:url(\"/assets/images/btn_add_mng.png\");background-size:80%;background-repeat:no-repeat}.ui.button.btnAddMobile{height:8vh;background:url(\"/assets/images/btn_addm.png\");background-size:80%;background-repeat:no-repeat}.ui.button.btnAddMobile:disabled{background-image:url(\"/assets/images/btn_addm.png\")!important;cursor:not-allowed}.ui.button.btnTransferMobile{height:8vh;background:url(\"/assets/images/btn_transfer.png\");background-size:80%;background-repeat:no-repeat}.ui.button.btnTransferMobile:disabled{background:url(\"/assets/images/btn_transfer.png\")!important;cursor:not-allowed;background-size:80%!important;background-repeat:no-repeat!important}.ui.button.btnBack{height:8vh;background:url(\"/assets/images/btn_back.png\");background-size:80%;background-repeat:no-repeat}.ui.button.btnCancel{height:8vh;background:url(\"/assets/images/btn_cancel.png\");background-size:80%;background-repeat:no-repeat}.ui.button.btnSubmitMobile{height:8vh;background-image:url(\"/assets/images/btn_submit.png\");background-size:80%;background-repeat:no-repeat}.ui.button.btnSubmitMobile:disabled{background-image:url(\"/assets/images/btn_submit.png\")!important;cursor:not-allowed;background-size:80%!important;background-repeat:no-repeat!important}.ui.button.btnClose{background:url(\"/assets/images/btn_close.png\");background-size:40%;background-repeat:no-repeat}.minWidth1Size{min-width:1vh}.minWidth1Size input{width:100%!important;min-width:1vh;font-size:.8em}.showStatus:hover+.hideStatus{display:block}.hideStatus{display:none}.fieldName{font-size:1em;font-weight:700;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}.subFieldName{font-size:1.2em}.subFieldName,.titleName{text-overflow:ellipsis;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}.titleName{font-size:1em;font-weight:700}.subTitleName{font-size:1.2em;text-overflow:ellipsis;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}.itemRow{height:40vh;overflow-y:auto}.itemRow .modalQtyValue{font-size:1.4em!important;margin-right:1vh;width:15vw;text-align-last:center}.itemRow.detail{overflow-x:hidden}.previewField{font-size:.5em;text-overflow:ellipsis;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}.previewField.preview{font-size:.1em}.previewValueField{font-size:.9em}.previewValueField.preview{font-size:.8em}.previewValueField.preview.long{line-height:2vh;padding-top:1vh}.previewValueField.long{line-height:10px;margin-top:1vh}.printPreview{height:200px;margin-top:12px}.printPreview .detail .row{margin-bottom:-27px}.printPreview .detail.preview{margin-top:5vh}.printPreview .detail.preview .row{margin-top:-4vh}.rowTagItem{padding:10px;border:1px solid #ccc;margin-bottom:2vh;border-radius:10px}.fieldHeader{font-size:.8em;margin-bottom:-2px;text-overflow:ellipsis;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}.fieldHeader .textBold{font-weight:700}@media{.page-break{display:flex}}@media print{body,html{height:auto!important;overflow:initial!important;-webkit-print-color-adjust:exact}}@media print{.page-break{margin-top:1rem;margin-bottom:1rem;display:block;page-break-before:auto}}@page{margin:0}.module.setupDisplay p{color:#fff}.module.tabletask{height:100vh;padding:2vh}.module.tabletask p{color:#fff}.module.tabletask .tablelist{height:85vh;overflow-y:auto;overflow-x:hidden}.module.tabletask .itemInfo{padding:15px;border-style:groove;border-width:1px;border-radius:10px;cursor:pointer}.module.setupTable{padding:25px;border-radius:20px;background-color:hsla(0,0%,90%,.44)}.module.setupTable p{color:#fff}.module.tabletaskOnJob{height:100vh;padding:2vh}.module.tabletaskOnJob p{color:#fff}.module.tabletaskOnJob .itemsBoxDetail{height:20vh;margin-bottom:1vh}.module.tabletaskOnJob .itemsBoxDetail,.module.tabletaskOnJob .itemsJobDetail{background-color:hsla(0,0%,41%,.909);padding:10px;border-radius:10px;overflow-y:hidden;overflow-x:hidden}.module.tabletaskOnJob .itemsJobDetail{margin-top:1vh;height:38.5vh}.module.tabletaskOnJob .itemsJobDetail.normal{height:19vh}.module.tabletaskOnJob .itemsJobDetail .itemScrool{overflow-x:hidden;overflow-y:auto;height:95%}.module.tabletaskOnJob .itemsJobDetail .item{margin-bottom:1vh;padding:10px;border:1px solid #adadad;border-radius:10px;cursor:pointer}.module.tabletaskOnJob .itemsJobDetail .item.nonecursor{cursor:default}.module.tabletaskOnJob .itemsJobDetail.active{border:2.5px solid #fff}.module.tabletaskOnJob .manage{margin-top:1vh;height:81vh;border-radius:10px;overflow-x:hidden;overflow-y:hidden}.module.tabletaskOnJob .manage.active{border:2.5px solid #fff}.module.tabletaskOnJob .itemJobDetail{height:67%}.module.tabletaskOnJob .itemJobDetail,.module.tabletaskOnJob .itemJobTime{margin-top:1vh;overflow-x:auto;padding:20px;border-radius:10px;background-color:rgba(61,60,60,.909)}.module.tabletaskOnJob .itemJobTime{height:30%}.module.tabletaskOnJob .workerList{padding:20px;border-radius:10px;background-color:hsla(0,0%,41%,.909);height:100%}.module.tabletaskOnJob .workerList .itemsL{padding-top:10px;overflow-y:auto;overflow-x:hidden;min-height:20vh;max-height:64vh}.module.tabletaskOnJob .workerList .itemsL .item [tabindex]:focus{outline:2px solid #fff}.module.tabletaskOnJob .workerList .itemsL .item:focus{outline:1px solid #fff;background-color:red}.module.tabletaskOnJob .startJobItem{padding:4vh;padding-top:6vh;border-radius:10px;background-color:hsla(0,0%,41%,.909);margin-top:1vh;height:58.5vh}.displayLanding,.loginAdmin{text-align:center}.loginAdmin{display:inline-block;padding:7vh;background-color:#fff;border-radius:2vh}.waitingText{font-size:4em;color:#fff;margin-top:4vh}.borderJobTime{border:1px solid #fff}.textSizeCaption{font-size:1em}.displayWorker{width:100%;height:100%;margin-top:2vh}.displayWorker .setupView .ui.container{width:auto;margin-left:auto!important;margin-right:auto!important}.displayWorker .setupView .ui.container .modalHeaderText{text-align:center;margin-top:2vh;font-size:2em;margin-bottom:2vh;color:#fff}.displayWorker .setupView .ui.container .ui.form .field .ui.input input,.displayWorker .setupView .ui.container .ui.form .fields .field .ui.input input{text-align:center;font-size:2em;height:4vh!important;border-radius:2vh;min-height:1.714286em}.displayWorker .setupView .ui.container .ui.selection.dropdown{line-height:3vh;border-radius:2vh}.displayWorker .setupView .ui.container .ui.selection.dropdown .icon{line-height:3vh}.displayWorker .ui{width:auto;margin-left:auto!important;margin-right:auto!important}.displayWorker .ui .ui.form .field .ui.input input,.displayWorker .ui .ui.form .fields .field .ui.input input{text-align:center;font-size:2em;height:3vh;border-radius:1vh}.displayWorker .inputWithRef{text-align:center;font-size:1.2em;height:3vh;border-radius:1vh;width:100%}.display.modalInput .ui.form .field .ui.input input,.display.modalInput .ui.form .fields .field .ui.input input{padding:1vh!important;font-weight:200;text-align:center;font-size:4em;height:7vh;border-radius:1vh}.display.modalInput .inputHeaderTitle{padding-top:3.5vh;padding-bottom:3vh}.display.modalInput .inputHeaderTitle .modalHeaderText{font-size:4em}.display.modalInput .inputWithRef{text-align:center;font-size:4.5em;height:6vh;border-radius:1vh;width:100%}.itemTask{overflow-wrap:break-word;font-size:1em;line-height:1.5}.reportViewSummary .reportHeaderText{font-size:2em}.reportViewSummary .detailSummary{height:22vh;background-color:#adb8c738;padding:1vh}.reportViewSummary .detailSummary .itemTaskHeader{font-size:1.4em;font-weight:900}.reportViewSummary .detailWrapData{font-size:1em!important;height:12.3vh;overflow-y:auto;overflow-x:hidden;margin-top:.8vh}.subTitleDetailMode{overflow-x:auto;height:71vh;padding-top:2vh;padding-bottom:2vh}.subTitleDetailMode .itemsListMark{background-color:#dcdcdc}.subTitleDetailMode .itemTask{font-size:1.4em}.Tab:focus{outline:none;box-shadow:0 0 5px 2px #61c5fa!important}[tabindex]:focus{outline:2px solid #fff}.button:focus{background-color:red}.suggestUiForKeyboardMode .title{padding:10px 0;font-size:1.8rem}.suggestUiForKeyboardMode .layoutClick{margin:20px 0;border:1px solid gray;padding:20px;width:20vw}.titleItemText{font-size:1.4rem}.wrapperNavBarDomain{background:#f8dbd0;width:98%;padding:12px;height:5vh;border-radius:4px;display:flex;justify-content:space-between;align-items:center}.wrapperNavBarDomain .navTextLogo{font-weight:700;font-size:18px;display:flex;align-items:center;cursor:pointer}.wrapperNavBarDomain .navTextLogo p{color:#737b88}.wrapperNavBarDomain .navTextLogo .globe{margin-bottom:3px;margin-right:4px}.wrapperNavBarDomain .action{display:flex;justify-content:flex-end;align-items:center}.wrapperNavBarDomain .action p{color:#737b88;font-size:12px;margin-right:12px}.wrapperNavBarDomain .action .user{margin-bottom:10px;margin-right:4px}.wrapperNavBarDomain .action .out{cursor:pointer;color:#e99778}.wrapperNavBarDomain .action .out:hover{color:#f8dbd0;background-color:#e99778}.containerLogin .textHeader{display:flex;justify-content:center}.containerLogin .textHeader .textHeaderCig{font-size:68px;font-weight:700;width:175px;color:#f4caba}.containerLogin .textHeader .textHeaderHub{color:#fffdfc;width:150px;font-size:68px;font-weight:700}.module.loginPD{text-align:center;margin:20px;margin-top:-50px;padding:38px 38px 24px;border-radius:8px;background-image:linear-gradient(-90deg,#fffdfc 50.1%,#f4caba 0),linear-gradient(-90deg,#fffdfc 50.1%,#f4caba 0);border-left:6px solid #f4caba;border-right:6px solid #fffdfc;background-size:100% 6px}.module.loginPD.withborder{padding:10px 0 20px;background-position:0 0,0 100%;background-repeat:no-repeat;margin-top:10px;padding-top:20px;padding-bottom:20px;margin:auto;width:50%;display:flex}.module.loginPD .signWithContainer{display:flex;flex-direction:column;color:#fffdfc;font-size:16px;font-weight:700;padding:12px;width:50%}.module.loginPD .signWithContainer .wayToSignin{display:flex;align-items:center;justify-content:center;height:100%}.module.loginPD .backendInputContainer{display:flex;flex-direction:column;padding:12px}.module.loginPD .backendInputContainer input{border-radius:8px}.module.loginPD .backendInputContainer input:active,.module.loginPD .backendInputContainer input:focus,.module.loginPD .backendInputContainer input:hover{border-color:#f4caba!important}.module.loginPD .backendInputContainer .loginButton{background-color:#f4caba;border-color:#f4caba;color:#fffdfc}.module.loginPD .textContainer{color:#f4caba;font-size:16px;font-weight:700}.module.loginPD .btnContainer,.module.loginPD .textContainer{width:50%;display:flex;justify-content:center;align-items:center}.module.loginPD .logoImage img{width:45rem;margin:0;display:inline-flex}.module.loginPD .headerText{font-size:2.5rem;font-weight:bolder;padding-bottom:4vh}.module.loginPD .wrapperReset{display:flex;justify-content:end}.module.loginPD .wrapperReset .resetText{text-align:right;opacity:.5!important;font-size:1rem;cursor:pointer}.module.loginPD .signInText{font-size:1.2rem;font-weight:700;padding-bottom:1vh}input{border-radius:8px}input:active,input:focus,input:hover{border-color:#f4caba!important}@media only screen and (min-width:768px) and (max-width:1024px){.module.loginPD.withborder{width:90%}}@media only screen and (min-width:0px) and (max-width:767px){.module.loginPD.withborder{width:90%;flex-direction:column;align-items:center}.module.loginPD span{color:#fffdfc;background:#f4caba;width:fit-content;padding:4px 8px;border-radius:4px;font-size:12px}.module.loginPD .officeLogin{width:100%;margin-top:6px}.module.loginPD .signWithContainer{width:100%;display:flex;justify-content:center;align-items:center}.backendInputContainer .loginButton{border:2px solid #ffff;border-color:#fff!important;background-color:#f3ad93}}.containerDomainManage{margin-top:14px}.containerDomainManage .table thead th{padding:11px!important;font-size:16px!important;background:#fbece6!important}.containerDomainManage .celled.table tr td{font-size:14px!important}.containerDomainManage .toggleActive,.containerDomainManage .wrapperBtnTable{display:flex;justify-content:center;align-items:center}.containerDomainManage .toggleActive .ui.toggle.checkbox input:checked~label:before{background-color:#eda88e!important}.containerDomainManage .buttonTable{width:24px;height:24px;display:flex;justify-content:center;align-items:center}.containerDomainManage .buttonTable i.icon{font-size:14px!important;height:unset!important}.containerDomainManage .textActions{display:none}.containerDomainManage .wrapperBtnCreate{display:flex;justify-content:flex-end}.containerDomainManage .wrapperBtnCreate button{padding:4px!important;font-size:12px!important;background:#f0b9a4}.containerDomainManage .wrapperBtnCreate button:hover{background:#eda88e}.containerDomainManage .wrapperBtnCreate .segment{margin-bottom:0;background:transparent;border-radius:4px;border:2px solid #fff;margin-right:10px}.containerDomainManage .wrapperBtnCreate .segment .ui.toggle.checkbox input:checked~label:before{background-color:#eda88e!important}.containerDomainManage .wrapperBtnCreate .segment label{font-size:12px!important}@media only screen and (min-width:0px) and (max-width:767px){.containerDomainManage .wrapperBtnTable button{margin-bottom:4px}.containerDomainManage .wrapperBtnTable .wrapperBtnActions{display:flex;align-items:center}.containerDomainManage .wrapperBtnTable .textActions{display:inline-block}.containerDomainManage .table thead{display:none!important}.containerDomainManage .toggleActive{display:flex;justify-content:flex-start;align-items:center}.containerDomainManage .toggleActive .textActions{display:inline-block}}.containerDomain{display:flex;justify-content:center}.containerDomain .domainCard{background-color:#f8dbd0;margin-top:3rem;padding:30px;font-size:18px;border-radius:16px;align-items:center;width:50%;border:3px solid #f0b9a4}.containerDomain .domainCard h1{text-align:center}.containerDomain .domainCard label{font-size:14px}.containerDomain .domainCard .ui.input{margin:5px 0 10px}.containerDomain .domainCard .buttonExpire{display:flex;justify-content:center}.containerDomain .domainCard .buttonExpire button{font-size:12px;margin-top:10px;margin-right:8px;line-height:18px}@media only screen and (min-width:0px) and (max-width:1440px){.domainCard{width:100%!important}}.containerAmthPage{width:100%}.containerAmthPage,.containerAmthPage .wrapperContent{display:flex;justify-content:center;align-items:center}.containerAmthPage .wrapperContent{flex-direction:column;width:60%}.containerAmthPage .wrapperContent .content{display:flex;justify-content:flex-start;background:#fffdfc;border-radius:4px;padding:20px 40px;min-height:150px;align-items:center;border:8px solid #f4caba}.containerAmthPage .wrapperContent .content p{font-weight:700;color:#f4caba}.containerAmthPage .wrapperContent .content .icon{font-size:20px;color:#f4caba;margin-right:4px}.containerAmthPage .wrapperContent .wrapperImg{display:flex;justify-content:center;align-items:center;padding:20px 40px;height:100%}.brinkImage{width:230px}.backIcon,.brinkImage{animation:brinkImage 1s cubic-bezier(1,0,0,1) infinite alternate}@keyframes brinkImage{to{opacity:0}}@media only screen and (min-width:0px) and (max-width:768px){.containerAmthPage .wrapperContent{width:80%}}@media only screen and (min-width:0px) and (max-width:425px){.containerAmthPage .wrapperContent{width:95%}.containerAmthPage .wrapperContent .content{flex-direction:column}}", ""]);

// exports


/***/ }),

/***/ 539:
/***/ (function(module, exports) {

module.exports = {"common":{"ok":"OK","cancel":"Cancel","back":"Back","welcome":"Welcome","hello":"Hello","somethingWrong":"Something Went Wrong, Please Try Again.","yourData":"Confirm Your Information.","validateError":"Validate error, Please fill in all require data.","validateCommentError":"Please enter a comment","attachError":"Upload error, Please choose file","squareInch":"SQUARE INCH","version":"Version","logout":"Log out","npiSystem":"NPI System","pageNotFound":"Page not found, Please re-check your url again.","unauthen":"Unauthorized, Please contact administrator for request access.","success":"Success","fail":"Fail","itemCode":"Item Code","itemStatus":"Item Status","code":"Code","name":"Name","accountNum":"Account No.","custName":"Customer Name","custGroup":"Customer Group","currency":"Currency","yes":"Yes","no":"No","right":"Right","left":"Left","edit":"Edit","reject":"Reject","search":"Search","lastUpdateBy":"Last Update by","create":"Create","view":"View","update":"Update","value":"Value","createFail":"Create Fail","updateFail":"Update Fail","upload":"Upload","comment":"Comment","close":"Close","confirm":"Confirm","save":"Save","chooseOptions":"Choose an option","add":"Add","submit":"Submit","transfer":"Transfer","scan":"Scan","receive":"Receive","deleteBy":"Delete By","print":"Print","duplicate":"Duplicate","enter":"Enter","scanId":"Scan ID for Booking","waitingForManager":"Waiting for Manager...","breakSection":"Break, Please Scan ID for Start","clearPD":"Clear PD","clearWorker":"Clear Worker","pdListAlert":"PD List Warning","workerListAlert":"Worker List Not Exist on System","delete":"Delete","pleaseContactAdminAx":"Please Contact AX Admin","pleaseCheckData":"Please Check Data","pleaseSelect":"Please Select Item","select":"Select","addRM":"Add RM","noWorker":"No Worker","noJobList":"No Job List"}}

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

module.exports = {"login":{"signin":"Sign in with o365","title":"Login","logout":"Logout","loginFail":"Login Fail","getUserInfoFail":"Get User Info Fail From Microsoft Graph"}}

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

module.exports = {"search":{"title":"Search","text":"Search","orderNo":"Order No.","drawingNo":"Drawing No.","customerName":"Customer Name","customerCode":"Customer Code","code":"Code","model":"Model","priority":"Priority","notFound":"Search Not Found","status":"Status","drawingRev":"Rev","coilSize":"Coil Size","pipeType":"Pipe type & Pattern","searchText":"Search","showLess":"Show Less","showAll":"Show All"}}

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

module.exports = {"header":{"material":"Material","special":"Special","assambly":"Assambly"}}

/***/ }),

/***/ 543:
/***/ (function(module, exports) {

module.exports = {"button":{"addTube":"Add Tube","addFin":"Add Fin","createDrawing":"Create Drawing","addPlate":"Add Plate","update":"Update","back":"Back","add":"Add","submit":"Submit"}}

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

module.exports = {"home":{"title":"NPI System","startDate":"Start Date","endDate":"End Date","user":"User","action":"Action","count":"Count","topActionByUser":"Top action by user","version":"Version"}}

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

module.exports = {"menu":{"drawingSystem":"Drawing System","drawingSystem2":"Drawing System New","about":"About","master":"Master Data","sellOrder":"Request Drawing","user":"Users","settings":"Settings","systemSettings":"System"}}

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

module.exports = {"share":{"rowsPerPage":"Rows","rangeSeparator":"of","noData":"No Data"}}

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

module.exports = {"user":{"no":"no.","name":"Name","empId":"Employee Id","isAdmin":"Is Admin","isNpiAdmin":"Is Npi","manage":"Manage Users","costCenterName":"Cost Center","viewList":"View Users","manageNpi":"Manage NPI admin","manageAdmin":"Manage Admin","edit":"Edit","submitNpiPermit":"Submit","cancel":"Cancel","backToList":"Back to List"}}

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

module.exports = {"master":{"setings":"Settings"}}

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

module.exports = {"warehouse":{"title":"Title","titleHome":"QR Tag","listTitle":"List Order","createTitle":"Transfer","imsTransferNo":"IMS Transfer No","from":"From","to":"To","date":"Date","createBy":"Create by","status":"Status","statusAX":"Complete on AX","fromWarehouse":"From Warehouse","toWarehouse":"To Warehouse","select":"Select","itemId":"Item No","itemName":"Item Name","onHandQTY":"On Hand Qty","requestQty":"Request Qty","qty":"Qty","receiveQty":"Receive Qty","unitId":"Unit","transfer":"Transfer","receiveTransfer":"Receive Transfer","batch":"Batch","searchItemNoName":"Search Item No. / Item Name","confirmTransfer":"Are you sure to create to transfer request?","successfullyTransfer":"Successfully Transfer Request","rmtag":"RM Tag","pdtag":"PD Tag","placeholderSearch":"Search Purchase Order / Invoice Account","purchaseNo":"Purchase No","packingSlipId":"Packing Slip","poNo":"PO No","invoiceAccount":"Invoice Account","receivedDate":"ReceiveDate","venderName":"Vender Name","purchaseType":"Purchase Type","approvalStatus":"Approval Status","deliveryDate":"Delivery Date","purchaseStatus":"Purchase Status","itemNo":"Item No","venderBatch":"Vender Batch","procurementCategory":"Procurement Category","unit":"Unit","tagUnit":"Tag (Unit)","purchaseOrderStatus":"Purchase Order Status","vendorAccount":"Vendor Account","inventLocationId":"InventLocation","cigInternalReference":"CIG Internal Reference","prodId":"Prod","prodPoolId":"Prod Pool","schedStart":"Date Start","schedEnd":"Date End"}}

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

module.exports = {"display":{"tableName":"Table Name","resource":"Resource","displayName":"Display Name","stationName":"Station Name","jobList":"Job List","jobListAssign":"JOB LIST ASSIGN","manageJob":"MANAGE JOB","noItems":"No Items","inputPd":"Input PD","qty":"Qty","inventLocationId":"Invent Location","productName":"Product Name","workerList":"Worker List","noWorker":"No Worker","pd":"PD","done":"Done","inputWorker":"Input Worker","":"","settingsDevice":"Setup Device","productionOrder":"Production Order","cigInternalRef":"CIG Internal Reference","detail":"Detail","dateNow":"Date (Now)","timeNow":"Time (Now)","plan":"Plan","remaining":"Remaining","spendingTime":"Spending Time","workerId":"Id","workerName":"Name","itemNo":"Item No.","itemName":"Item Name","quantity":"Quantity","journal":"Journal","station":"Station","reportAsFinish":"Report as Finish","picking":"Picking","jobCard":"Job Card","wareHouse":"WareHouse","goodQuantity":"Good Quantity","line":"Line","proposal":"Proposal","consumption":"Consumption","remainder":"Remainder","scrap":"Scrap","addScrap":"Add Scrap","finish":"Finish","scrapNo":"Scrap No.","description":"Description","errorQty":"Error Qty.","errorScrap":"Error Scrap","breakDown":"Break Down","otherProblem":"Other Problem","changeOnMaterial":"Change On Material","changeOnPicking":"Change On Picking","changeOnOther":"Change on site/warehouse/location","other":"other","faultReport":"Fault Report","addBreakDown":"Add Break Down","breakDownReportAsFinish":"Break Down Report as Finish","breakDownWithoutReport":"Break Down Without Report","breakDownCause":"Break Down Cause","startTime":"Start Time","endTime":"End Time","setup":"Setup","process":"Process","start":"Start","end":"End","mins":"minutes","hours":"hours","next":"Next","worker":"Worker","setWorker":"Set Worker","addWorker":"Add Worker","material":"Material","onHandQty":"On hand","unit":"Unit","materialWarehouse":"Material Warehouse","materialQty":"Material Qty","changeMaterial":"Change Material","addMaterial":"Add Material","addPD":"Add PD","setPD":"Set PD","addRM":"Add RM"},"displayModalMsg":{"removeTableList":"confirm to remove table","":""}}

/***/ }),

/***/ 551:
/***/ (function(module, exports) {

module.exports = {"common":{"ok":"ตกลง","cancel":"ยกเลิก","back":"กลับ","welcome":"ยินดีต้อนรับ","hello":"สวัสดี","somethingWrong":"เกิดความผิดพลาด ลองใหม่อีกครั้ง","yourData":"ข้อมูลที่จะทำการบันทึก","validateError":"ไม่สามารถทำรายการต่อไปได้ กรุณากรอกข้อมูลให้ครบถ้วน","validateCommentError":"กรุณาแสดงความคิดเห็น","attachError":"ไม่สามารถอัพโหลดไฟล์ได้ เนื่องจากท่านยังไม่ได้ทำการเลือกไฟล์","squareInch":"SQUARE INCH","version":"เวอร์ชัน","logout":"ออกจากระบบ","npiSystem":"ระบบ NPI","pageNotFound":"ไม่พบข้อมูล กรุณาตรวจสอบ url อีกครั้ง","unauthen":"ไม่มีสิทธิเข้าใช้งาน, กรุณาติดต่อเจ้าหน้าที่ เพื่อขอสิทธิใช้งาน","success":"สำเร็จ","fail":"ไม่สำเร็จ","itemCode":"รหัสรายการ","itemStatus":"สถานะ","code":"Code","name":"Name","accountNum":"Account No.","custName":"Customer Name","custGroup":"Customer Group","currency":"Currency","yes":"Yes","no":"No","left":"Left","right":"Right","edit":"Edit","reject":"Reject","search":"Search","lastUpdateBy":"แก้ไขโดย","create":"เพิ่ม","view":"ดูรายละเอียด","update":"แก้ไข","value":"Value","createFail":"บันทึกไม่สำเร็จ","updateFail":"ปรับปรุงไม่สำเร็จ","upload":"อัพโหลด","comment":"ส่งข้อความ","close":"ปิด","confirm":"ยืนยัน","save":"บันทึก","chooseOptions":"Choose an option","add":"Add","submit":"Submit","transfer":"Transfer","scan":"Scan","receive":"Receive","deleteBy":"ลบโดย","print":"พิมพ์","duplicate":"Duplicate","enter":"Enter","scanId":"Scan ID for Booking","waitingForManager":"Waiting for Manager...","breakSection":"อยู่ระหว่างพัก กรุณาแตะบัตรเพื่อเริ่มการทำงานอีกครั้ง","clearPD":"Clear PD","clearWorker":"Clear Worker","pdListAlert":"PD List Warning","workerListAlert":"Worker List Not Exist on System","delete":"Delete","pleaseContactAdminAx":"Please Contact AX Admin","pleaseCheckData":"Please Check Data","pleaseSelect":"Please Select Item","select":" Select","addRM":"Add RM","noWorker":"No Worker","noJobList":"No Job List"}}

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

module.exports = {"login":{"signin":"ลงชื่อเข้าใช้ด้วย o365","title":"ลงชื่อเข้าใช้","logout":"ลงชื่อออก","loginFail":"ลงชื่อเข้าใช้งาน ไม่สำเร็จ","getUserInfoFail":"ดึงข้อมูลจาก Microsoft Graph ไม่สำเร็จ"}}

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

module.exports = {"button":{"addTube":"Add Tube","addFin":"Add Fin","createDrawing":"Create Drawing","addPlate":"Add Plate","update":"Update","back":"Back","add":"Add","submit":"Submit"}}

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

module.exports = {"home":{"title":"NPI System","startDate":"วันที่เริ่มต้น","endDate":"วันที่สิ้นสุด","user":"ผู้ใช้งาน","action":"สถานะ","count":"จำนวน","topActionByUser":"ผู้ใช้งานที่ใช้งานสูงสุด ในแต่ละสถานะ","version":"เวอร์ชัน"}}

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

module.exports = {"menu":{"drawingSystem":"ระบบบันทึก Drawing","drawingSystem2":"ระบบบันทึก Drawing 2","about":"รายละเอียด","master":"ข้อมูล เริ่มต้น","sellOrder":"ระบบันทึกแบบ Sale","user":"ผู้ใช้งาน","settings":"ตั้งค่า","systemSettings":"ระบบ"}}

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

module.exports = {"share":{"rowsPerPage":"จำนวน","rangeSeparator":"จาก","noData":"ไม่มีข้อมูล"}}

/***/ }),

/***/ 557:
/***/ (function(module, exports) {

module.exports = {"user":{"no":"no.","name":"ชื่อ","empId":"รหัสพนักงาน","isAdmin":"สิทธิ Admin","isNpiAdmin":"สิทธิ Npi","manage":"รายละเอียด ผู้ใช้งาน","costCenterName":"หน่วยงาน","viewList":"รายละเอียดผู้ใช้งาน","manageNpi":"จัดการ สิทธิ NPI","manageAdmin":"จัดการ สิทธิ Admin","edit":"แก้ไข","submitNpiPermit":"Submit","cancel":"Cancel","backToList":"กลับหน้า รายละเอียดผู้ใช้งาน"}}

/***/ }),

/***/ 558:
/***/ (function(module, exports) {

module.exports = {"master":{"setings":"การตั้งค่า"}}

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

module.exports = {"warehouse":{"title":"Title","titleHome":"QR Tag","listTitle":"List Order","createTitle":"Transfer","imsTransferNo":"IMS Transfer No","from":"From","to":"To","date":"Date","createBy":"Create by","status":"Status","statusAX":"Complete on AX","fromWarehouse":"From Warehouse","toWarehouse":"To Warehouse","select":"Select","itemId":"Item No","itemName":"Item Name","onHandQTY":"On Hand Qty","requestQty":"Request Qty","qty":"Qty","receiveQty":"Receive Qty","unitId":"Unit","transfer":"Transfer","receiveTransfer":"Receive Transfer","batch":"Batch","searchItemNoName":"Search Item No. / Item Name","confirmTransfer":"Are you sure to create to transfer request?","successfullyTransfer":"Successfully Transfer Request","rmtag":"RM Tag","pdtag":"PD Tag","placeholderSearch":"Search Purchase Order / Invoice Account","purchaseNo":"Purchase No","packingSlipId":"Packing Slip","poNo":"PO No","invoiceAccount":"Invoice Account","receivedDate":"ReceiveDate","venderName":"Vender Name","purchaseType":"Purchase Type","approvalStatus":"Approval Status","deliveryDate":"Delivery Date","purchaseStatus":"Purchase Status","itemNo":"Item No","venderBatch":"Vender Batch","procurementCategory":"Procurement Category","unit":"Unit","tagUnit":"Tag (Unit)","purchaseOrderStatus":"Purchase Order Status","vendorAccount":"Vendor Account","inventLocation":"Invent Location","cigInternalReference":"CIG Internal Reference","prodId":"Prod","prodPoolId":"Prod Pool","schedStart":"Date Start","schedEnd":"Date End"}}

/***/ }),

/***/ 560:
/***/ (function(module, exports) {

module.exports = {"display":{"tableName":"Table Name","resource":"Resource","displayName":"ชื่อหน้าจอ","stationName":"ชื่อเครื่อง","jobList":"รายการงาน","jobListAssign":"รายการงาน","manageJob":"จัดการงาน","noItems":"ไม่ม่รายการ","inputPd":"กรอก PD","qty":"จำนวน","inventLocationId":"Invent Location","productName":"ชื่อผลิตภัณฑ์","workerList":"รายชื่อพนักงาน","noWorker":"ไม่มีพนักงาน","pd":"PD","done":"Done","inputWorker":"Input Worker","":"","settingsDevice":"ตั้งค่าอุปกรณ์","cigInternalRef":"CIG Internal Reference","productionOrder":"Production Order","detail":"รายละเอียด","dateNow":"วันที่ (ปัจจุบัน)","timeNow":"เวลา (ปัจจุบัน)","plan":"กำหนด","remaining":"คงเหลือ","spendingTime":"เวลาที่ใช้ไป","workerId":"เลขประจำตัว","workerName":"ชื่อ","itemNo":"รหัสสินค้า","itemName":"ชื่อสินค้า","quantity":"จำนวนสั่งผลิต","journal":"Journal","station":"Station","reportAsFinish":"Report as Finish","picking":"Picking","jobCard":"Job Card","wareHouse":"WareHouse","goodQuantity":"Good Quantity","line":"Line","proposal":"Proposal","consumption":"Consumption","remainder":"Remainder","scrap":"Scrap","addScrap":"เพิ่มรายการของเสีย","finish":"เสร็จสิ้น","scrapNo":"รหัสของเสีย","description":"รายละะอียด","errorQty":"Error Qty.","errorScrap":"จำนวนของเสีย","breakDown":"Break Down","otherProblem":"Other Problem","changeOnMaterial":"Change On Material","changeOnPicking":"Change On Picking","changeOnOther":"Change on site/warehouse/location","other":"other","faultReport":"Fault Report","addBreakDown":"Add Break Down","breakDownReportAsFinish":"Break Down Report as Finish","breakDownWithoutReport":"Break Down Without Report","breakDownCause":"Break Down Cause","startTime":"เวลาเริ่มต้น","endTime":"เวลาสิ้นสุด","setup":"ตั้งเครื่อง","process":"ดำเนินการ","start":"เริ่ม","end":"จบ","next":"ถัดไป","mins":"นาที","hours":"ชั่วโมง","worker":"พนักงาน","setWorker":"ตั้งค่าพนักงาน","addWorker":"เพิ่มพนักงาน","material":"Material","onHandQty":"On hand","unit":"Unit","materialWarehouse":"Material Warehouse","materialQty":"Material Qty","changeMaterial":"Change Material","addMaterial":"Add Material","addPD":"Add PD","setPD":"Set PD","addRM":"Add RM"},"displayModalMsg":{"removeTableList":"confirm to remove table"}}

/***/ })

},[251]);


// WEBPACK FOOTER //
// app.217c73355b440667d950.js